import { ref as M, defineComponent as b, createBlock as v, openBlock as d, unref as e, reactive as Ft, watch as R, toRefs as zt, computed as V, shallowRef as A, onMounted as Fe, createSlots as Z, withCtx as i, createElementVNode as h, toDisplayString as S, createVNode as a, createTextVNode as O, renderSlot as B, normalizeStyle as pt, createCommentVNode as x, withModifiers as Ne, mergeModels as jt, useModel as ce, createElementBlock as L, Fragment as N, nextTick as Ie, renderList as re, mergeProps as Y, withDirectives as he, vShow as ze, isRef as oe, watchEffect as Pt, normalizeClass as Rt, resolveComponent as Ht, onBeforeMount as Ke, onBeforeUnmount as Et, useCssVars as qt, onServerPrefetch as Wt } from "vue";
import { defineStore as G } from "pinia";
import { VSnackbarQueue as Zt } from "vuetify/components/VSnackbarQueue";
import { mdiStorefront as Gt, mdiSync as Qt, mdiSyncOff as Yt, mdiLogoutVariant as Jt, mdiFullscreenExit as Xt, mdiFullscreen as Kt, mdiCheck as Ae, mdiSelect as eo, mdiSpaceInvaders as mt, mdiImageFilterHdr as ft, mdiTransmissionTower as vt, mdiRocketLaunchOutline as gt, mdiHome as to, mdiTextBox as oo, mdiWhiteBalanceSunny as no, mdiWeatherNight as so, mdiDesktopTowerMonitor as ao, mdiContrastCircle as io, mdiCog as ro, mdiCogOutline as lo, mdiFileDocument as uo, mdiCreditCardSettingsOutline as co, mdiRocketOutline as po, mdiCheckCircleOutline as Me, mdiCreditCard as mo, mdiReload as fo, mdiPlaylistCheck as vo, mdiCreditCardOutline as go, mdiOpenInNew as je, mdiMedal as _o, mdiHandHeart as ho, mdiHandHeartOutline as yo, mdiCloudDownload as bo, mdiTrayArrowDown as ut, mdiAccountGroup as Vo, mdiAccount as ko, mdiLinkVariant as $o, mdiContentCopy as wo, mdiShieldLock as ct, mdiAccountRemoveOutline as xo, mdiExitToApp as Co, mdiAccountGroupOutline as So, mdiEmailOpenOutline as _t, mdiEmailVariant as ht, mdiBell as Lo, mdiInboxOutline as Io, mdiInboxFullOutline as Ao, mdiBillboard as Do, mdiBellOutline as To, mdiViewDashboardOutline as Uo, mdiCrown as Oo, mdiArrowULeftBottom as Bo, mdiAtomVariant as No, mdiLogin as dt, mdiShieldStarOutline as Mo } from "@mdi/js";
import { merge as Ge } from "lodash-es";
import { useRoute as Fo, useRouter as et } from "vue-router";
import { VListItem as ye, VList as de, VListSubheader as zo, VListItemTitle as yt, VListItemSubtitle as jo } from "vuetify/components/VList";
import { VAvatar as ne } from "vuetify/components/VAvatar";
import { VCard as E, VCardTitle as Po, VCardSubtitle as Ro, VCardText as ae, VCardItem as Qe, VCardActions as Ho } from "vuetify/components/VCard";
import { VDialog as tt } from "vuetify/components/VDialog";
import { VBadge as ot } from "vuetify/components/VBadge";
import { VBtn as z } from "vuetify/components/VBtn";
import { VProgressCircular as Eo } from "vuetify/components/VProgressCircular";
import { VSheet as Pe } from "vuetify/components/VSheet";
import { VSwitch as nt } from "vuetify/components/VSwitch";
import { VFadeTransition as Re, VExpandTransition as be, VExpandXTransition as qo } from "vuetify/components/transitions";
import { useDisplay as me, useTheme as He, useDate as De } from "vuetify";
import { VDivider as J } from "vuetify/components/VDivider";
import { VIcon as D } from "vuetify/components/VIcon";
import { VLabel as Je } from "vuetify/components/VLabel";
import { VChip as ie } from "vuetify/components/VChip";
import { VChipGroup as Wo } from "vuetify/components/VChipGroup";
import { VSelect as Zo } from "vuetify/components/VSelect";
import { VRow as Te, VCol as _e, VSpacer as Go } from "vuetify/components/VGrid";
import { VHover as Ee } from "vuetify/components/VHover";
import { VImg as le } from "vuetify/components/VImg";
import { VItemGroup as bt, VItem as Xe } from "vuetify/components/VItemGroup";
import { VLayout as Ve } from "vuetify/components/VLayout";
import { VMain as ke } from "vuetify/components/VMain";
import { VDataTableVirtual as Vt, VDataTable as Qo } from "vuetify/components/VDataTable";
import { VSkeletonLoader as Le } from "vuetify/components/VSkeletonLoader";
import { VWindow as kt, VWindowItem as Se } from "vuetify/components/VWindow";
import { VTimelineItem as Yo, VTimeline as Jo } from "vuetify/components/VTimeline";
import { VEmptyState as st } from "vuetify/components/VEmptyState";
import { VMenu as $t } from "vuetify/components/VMenu";
import { VTextField as Xo } from "vuetify/components/VTextField";
import { Tooltip as Ko, Ripple as en } from "vuetify/directives";
import { VTooltip as se } from "vuetify/components/VTooltip";
import { VResponsive as tn } from "vuetify/components/VResponsive";
import { VNavigationDrawer as on } from "vuetify/components/VNavigationDrawer";
import { VColorPicker as nn } from "vuetify/components/VColorPicker";
import { VAppBar as wt } from "vuetify/components/VAppBar";
import { VFooter as sn } from "vuetify/components/VFooter";
import { VLazy as an } from "vuetify/components/VLazy";
const xt = G("Queue", () => {
  const u = M([]);
  function t(o) {
    const r = typeof o == "string" ? { text: o } : o;
    u.value.push(r);
  }
  function s(o) {
    t({
      color: "error",
      text: o,
      location: "top end",
      timeout: -1
    });
  }
  return {
    queue: u,
    show: t,
    showError: s
  };
}), rn = /* @__PURE__ */ b({
  __name: "VoSnackbarQueue",
  setup(u) {
    const t = xt();
    return (s, o) => (d(), v(Zt, {
      modelValue: e(t).queue,
      "onUpdate:modelValue": o[0] || (o[0] = (r) => e(t).queue = r),
      closable: "",
      location: "bottom end"
    }, null, 8, ["modelValue"]));
  }
}), K = G("http", {
  state: () => ({
    url: ""
  }),
  actions: {
    async fetch(u, t = {}) {
      const s = await fetch(`${this.url}${u}`, {
        credentials: "include",
        ...t
      });
      if (!s.ok)
        throw new Error(await s.text());
      return s.status === 204 ? {} : s.json();
    },
    async post(u, t, s = {}) {
      return this.fetch(u, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(t),
        ...s
      });
    },
    async form(u, t, s = {}) {
      return this.fetch(u, {
        method: "POST",
        body: t,
        ...s
      });
    },
    async get(u, t = {}) {
      return this.fetch(u, t);
    },
    async delete(u, t = {}) {
      return this.fetch(u, {
        method: "DELETE",
        ...t
      });
    }
  }
}), Ye = typeof window < "u", Be = {
  v: 5,
  api: "link-only",
  avatar: "",
  dev: !1,
  disableAds: !1,
  composition: "composition",
  pwaRefresh: !0,
  theme: "system",
  mixedTheme: !0,
  direction: "ltr",
  pins: !1,
  pinned: [],
  slashSearch: !1,
  syncSettings: !0,
  showHouseAds: !1,
  quickbar: !1,
  railDrawer: !1,
  suits: {
    show: !1,
    elements: ["app-bar"],
    suit: ""
  },
  colors: {
    one: "surface-light"
  },
  notifications: {
    show: !0,
    banners: !0,
    read: [],
    last: {
      banner: [],
      v2banner: null,
      install: null,
      notification: null,
      promotion: null,
      jobs: null
    }
  }
}, j = G("user", () => {
  const u = Ft(Ge({}, Be));
  R(u, s);
  function t() {
    if (!Ye)
      return;
    const r = localStorage.getItem("vuetify@user"), n = r ? JSON.parse(r) : {};
    let l = n.v === u.v;
    n.v || (n.pwaRefresh = !0, typeof n.api == "boolean" && (n.api = n.api ? "inline" : "link-only"), typeof n.rtl == "boolean" && (n.direction = n.rtl ? "rtl" : "ltr", delete n.rtl), typeof n.theme == "object" && (n.mixedTheme = n.theme.mixed, n.theme = n.theme.system ? "system" : n.theme.dark ? "dark" : "light"), Array.isArray(n.notifications) && (n.notifications = { read: n.notifications }), typeof n.last == "object" && (n.notifications.last = n.last, delete n.last)), n.v === 1 && (Array.isArray(n.composition) && (n.composition = "composition"), Array.isArray(n.notifications.last.banner) || (n.notifications = n.notifications || {}, n.notifications.last = n.notifications.last || {}, n.notifications.last.banner = [])), n.v === 2 && (n.syncSettings = !0, n.disableAds = !1, n.v = 3), n.v === 3 && (n.quickbar = !1), n.v === 4 && (n.suits = Be.suits, n.notifications.banners = Be.notifications.banners, l = !0), n.v = u.v, Object.assign(u, Ge(u, n)), l && s();
  }
  function s() {
    Ye && localStorage.setItem("vuetify@user", JSON.stringify(u, null, 2));
  }
  function o() {
    Ye && (Object.assign(u, Ge({}, Be)), s());
  }
  return t(), {
    ...zt(u),
    load: t,
    save: s,
    reset: o
  };
});
function fe() {
  const u = Fo();
  return V(
    () => u.query
  );
}
const $e = G("team", () => {
  const u = fe(), t = q(), s = F(), o = K(), r = xt(), n = A(!1), l = M(null), c = M(!1), p = V(() => u.value.invite), m = V(
    () => {
      var y;
      return l.value ? (y = s.access) == null ? void 0 : y.some(($) => ["one/team", "snips/team"].includes($)) : !1;
    }
  );
  R(p, async () => {
    if (p.value) {
      t.user || (t.dialog = !0);
      try {
        n.value = !0;
        const y = await o.get(`/one/team/${p.value}`);
        l.value = y.team, c.value = !0;
      } catch (y) {
        _(), r.showError(y.message);
      } finally {
        n.value = !1;
      }
    }
  }, { immediate: !0 });
  async function g(y) {
    try {
      if (n.value = !0, !l.value)
        return;
      await o.post("/one/team/remove", { userId: y }), l.value.members = l.value.members.filter(($) => $.id !== y);
    } catch ($) {
      r.showError($.message);
    } finally {
      n.value = !1;
    }
  }
  async function f() {
    var y;
    try {
      n.value = !0, await o.post("/one/team/leave", { teamId: (y = l.value) == null ? void 0 : y.id }), await t.verify(!0);
    } catch ($) {
      r.showError($.message);
    } finally {
      n.value = !1;
    }
  }
  async function C() {
    try {
      n.value = !0, await o.post("/one/team/join", { inviteCode: p.value }), await t.verify(!0), _();
    } catch (y) {
      r.showError(y.message);
    } finally {
      n.value = !1;
    }
  }
  function _() {
    c.value = !1;
    const y = new URL(window.location.href);
    y.searchParams.delete("invite"), window.history.replaceState({}, "", y.toString());
  }
  const k = V(() => {
    var y, $, T;
    return ((y = t.user) == null ? void 0 : y.id) === ((T = ($ = t.user) == null ? void 0 : $.team) == null ? void 0 : T.owner.id);
  });
  return {
    team: l,
    teamInviteDialog: c,
    teamInviteCode: p,
    hasTeamAccess: m,
    isTeamOwner: k,
    isLoading: n,
    removeFromTeam: g,
    leaveTeam: f,
    joinTeam: C,
    clearTeamQuery: _
  };
}), F = G("one", () => {
  const u = fe(), t = et(), s = q(), o = K(), r = $e(), n = A(!1), l = A(!1), c = M(), p = M([]), m = V(() => u.value.session_id), g = V(() => {
    var w;
    return (w = c.value) == null ? void 0 : w.items[0].plan.interval;
  }), f = V(() => {
    var w;
    return (w = c.value) == null ? void 0 : w.items[0].plan.type;
  }), C = M([]), _ = V(() => {
    var w;
    return (w = s.user) == null ? void 0 : w.sponsorships.find((I) => I.platform === "stripe" && I.tierName.startsWith("sub_"));
  }), k = V(() => {
    var w;
    return !!((w = _.value) != null && w.tierName);
  }), y = V(() => {
    var w;
    return ((w = s.user) == null ? void 0 : w.sponsorships.reduce((I, H) => {
      if (!H.isActive || H.interval === "once" || H.platform === "stripe")
        return I;
      const Oe = ["teamMonth", "soloMonth"].includes(H.interval) ? H.amount : H.amount / 12;
      return I + Oe / 100;
    }, 0)) ?? 0;
  }), $ = V(() => {
    var w;
    return (w = s.user) == null ? void 0 : w.sponsorships.find((I) => I.tierName.startsWith("sub_") && I.isActive);
  }), T = V(() => {
    var w;
    return (w = s.user) == null ? void 0 : w.sponsorships.find((I) => I.platform === "github" && I.isActive);
  }), U = V(() => {
    var w;
    return (w = s.user) == null ? void 0 : w.sponsorships.find((I) => I.platform === "discord" && I.isActive);
  }), P = V(() => {
    var w;
    return (w = s.user) == null ? void 0 : w.identities.find((I) => I.provider === "shopify");
  }), Q = V(() => {
    var w, I, H, Oe;
    return !o.url || ((w = s.user) == null ? void 0 : w.isAdmin) || ((I = _.value) == null ? void 0 : I.isActive) || ((H = T.value) == null ? void 0 : H.isActive) || ((Oe = U.value) == null ? void 0 : Oe.isActive) || y.value >= 2.99;
  });
  Fe(async () => {
    m.value && await W();
  }), R(l, Ce), R(m, async (w) => {
    w && await W();
  }, { immediate: !0 }), R(u, (w) => {
    if (w.one !== "subscribe" || s.user)
      return;
    s.dialog = !0;
    const I = R(() => s.user, (H) => {
      H && (s.dialog = !1, I());
    });
  }, { immediate: !0 }), R(Q, (w, I) => {
    w === !1 && I !== !0 || te();
  });
  async function W() {
    try {
      n.value = !0, await o.post("/one/activate", { sessionId: m.value }), await s.verify(!0), await xe();
      const w = new URL(window.location.href), I = w.searchParams;
      I.delete("session_id"), I.delete("team"), history.pushState(null, "", w.toString());
    } catch {
    } finally {
      n.value = !1;
    }
  }
  async function X() {
    window.open(`${o.url}/one/manage`, "_blank");
  }
  async function ue(w, I) {
    n.value = !0;
    const H = new URL("/one/subscribe", o.url);
    H.searchParams.set("interval", w), H.searchParams.set("type", I), window.location.href = H.toString();
  }
  async function pe() {
    var w;
    if (_.value)
      try {
        n.value = !0;
        const I = await o.post(
          `/one/cancel?subscriptionId=${(w = _.value) == null ? void 0 : w.tierName}`
        );
        s.user = I.user;
      } catch {
      } finally {
        n.value = !1;
      }
  }
  async function ge(w, I) {
    if (_.value)
      try {
        n.value = !0, await o.post("/one/modify", {
          subscriptionId: _.value.tierName,
          interval: w,
          type: I
        }), await te();
      } catch {
      } finally {
        n.value = !1;
      }
  }
  async function te() {
    var w, I;
    if (_.value)
      try {
        n.value = !0;
        const H = await o.post(
          `/one/verify?subscriptionId=${(w = _.value) == null ? void 0 : w.tierName}`
        );
        s.user = H.user, C.value = H.access, r.team = ((I = s.user) == null ? void 0 : I.team) ?? null;
      } catch {
      } finally {
        n.value = !1;
      }
  }
  async function xe() {
    try {
      n.value = !0;
      const w = await o.get("/one/info");
      return c.value = w.subscription, p.value = w.invoices, w;
    } catch {
    } finally {
      n.value = !1;
    }
  }
  function Ce() {
    t.push({
      query: {
        ...u.value,
        one: void 0
      }
    });
  }
  return {
    info: c,
    interval: g,
    subscriptionType: f,
    access: C,
    invoices: p,
    sessionId: m,
    subscription: _,
    monthlyTotal: y,
    hasBilling: k,
    isLoading: n,
    isOpen: l,
    isSubscriber: Q,
    github: T,
    discord: U,
    shopify: P,
    one: $,
    activate: W,
    cancel: pe,
    manage: X,
    modify: ge,
    resetQuery: Ce,
    subscribe: ue,
    subscriptionInfo: xe,
    verify: te
  };
}), q = G("auth", () => {
  const u = M(!1), t = M(null), s = K(), o = j(), r = et(), n = A(!1), l = F(), c = $e();
  let p = !!k();
  R(t, (y) => {
    if (!(y != null && y.settings))
      return;
    const $ = localStorage.getItem("vuetify@user") || "{}";
    JSON.stringify(y.settings, null, 2) !== $ && (p = !0, Object.assign(o, y.settings));
  }), o.$subscribe(() => {
    p || m(), p = !1;
  });
  async function m() {
    if (!(!t.value || !o.syncSettings))
      try {
        await s.post("/user/settings", { settings: o.$state });
      } catch (y) {
        console.error(y);
      }
  }
  async function g(y = !1) {
    var $, T;
    if (g.promise)
      return g.promise;
    if (!y && !document.cookie.includes("sx=1") && (($ = location.hostname.match(/([^.]+\.[^.]+)$/)) == null ? void 0 : $[1]) === ((T = new URL(s.url).hostname.match(/([^.]+\.[^.]+)$/)) == null ? void 0 : T[1])) {
      t.value = null;
      return;
    }
    n.value = !0, g.promise = fetch(`${s.url}/auth/verify`, {
      credentials: "include",
      cache: y ? "reload" : void 0
    }).then(
      async (U) => {
        var P;
        if (U.ok || U.status === 401) {
          const Q = await U.json();
          t.value = Q.user, l.access = Q.access, c.team = (P = Q.user) == null ? void 0 : P.team;
        } else
          console.error(U.statusText);
      },
      () => {
      }
    ).finally(() => {
      n.value = !1, g.promise = null;
    });
  }
  g.promise = null;
  async function f(y = "github") {
    n.value = !0;
    const $ = `${s.url}/auth/${y}/redirect`;
    if (y === "shopify") {
      window.location.assign($ + "?next=" + encodeURIComponent(window.location.href));
      return;
    }
    const T = 400, U = 600, P = window.screenX + (window.innerWidth - T) / 2, Q = window.screenY + (window.innerHeight - U) / 2, W = window.open(
      "",
      "vuetify:authorize:popup",
      `popup,left=${P},top=${Q},width=${T},height=${U},resizable`
    );
    if (!W) {
      console.error("Failed to open popup");
      return;
    }
    W.location.href = $;
    let X = -1, ue = -1;
    function pe(te) {
      var xe, Ce;
      te.origin === s.url && ((xe = te.data) == null ? void 0 : xe.type) === "auth-response" && (te.data.status === "success" ? (t.value || localStorage.setItem("vuetify@lastLoginProvider", y), t.value = te.data.body.user, l.access = te.data.body.access, c.team = (Ce = te.data.body.user) == null ? void 0 : Ce.team, m()) : console.error(te.data.message), ge());
    }
    function ge() {
      window.removeEventListener("message", pe), window.clearInterval(X), window.clearTimeout(ue), W == null || W.close(), n.value = !1;
    }
    window.addEventListener("message", pe), X = window.setInterval(() => {
      !W || W.closed ? (console.error("Auth popup closed"), ge()) : W.postMessage({ type: "auth-request" }, "*");
    }, 1e3), ue = window.setTimeout(() => {
      ge(), console.error("Auth timed out");
    }, 120 * 1e3);
  }
  async function C(y) {
    n.value = !0;
    const $ = y ? `/auth/${y}/logout` : "/auth/logout";
    try {
      await s.post($), await g(!0), t.value = null;
    } catch (T) {
      console.error(T);
    } finally {
      r.push({
        path: "/",
        query: r.currentRoute.value.query
      }), n.value = !1;
    }
  }
  function _(y) {
    var $;
    return ($ = t.value) == null ? void 0 : $.identities.find((T) => T.provider === y);
  }
  function k() {
    return localStorage.getItem("vuetify@lastLoginProvider");
  }
  return g(), {
    user: t,
    url: s.url,
    dialog: u,
    isLoading: n,
    verify: g,
    findIdentity: _,
    login: f,
    logout: C,
    lastLoginProvider: k,
    sync: m
  };
}), ln = { class: "text-body-2" }, Ct = /* @__PURE__ */ b({
  __name: "VoAuthShopify",
  setup(u) {
    const t = q(), s = V(() => t.user && t.findIdentity("shopify")), o = V(() => t.user ? s.value ? "Connected to Shopify" : "Connect Shopify" : "Login with Shopify");
    return (r, n) => (d(), v(ye, {
      "base-color": "#5b8a3c",
      "prepend-icon": `svg:${e(Gt)}`,
      rounded: "pill",
      slim: "",
      variant: "flat",
      onClick: n[0] || (n[0] = (l) => e(t).login("shopify"))
    }, Z({
      title: i(() => [
        h("span", ln, S(e(o)), 1)
      ]),
      _: 2
    }, [
      !e(t).user && e(t).lastLoginProvider() === "shopify" ? {
        name: "subtitle",
        fn: i(() => [
          n[1] || (n[1] = h("div", { class: "text-caption mt-n1" }, "Last Used", -1))
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["prepend-icon"]));
  }
}), un = { class: "text-body-2" }, St = /* @__PURE__ */ b({
  __name: "VoAuthDiscord",
  setup(u) {
    const t = q(), s = V(() => t.user && t.findIdentity("discord")), o = V(() => t.user ? s.value ? "Connected to Discord" : "Connect Discord" : "Login with Discord");
    return (r, n) => (d(), v(ye, {
      "base-color": "#5865F2",
      "prepend-icon": "$discord",
      rounded: "pill",
      slim: "",
      variant: "flat",
      onClick: n[0] || (n[0] = (l) => e(t).login("discord"))
    }, Z({
      title: i(() => [
        h("span", un, S(e(o)), 1)
      ]),
      _: 2
    }, [
      !e(t).user && e(t).lastLoginProvider() === "discord" ? {
        name: "subtitle",
        fn: i(() => [
          n[1] || (n[1] = h("div", { class: "text-caption mt-n1" }, "Last Used", -1))
        ]),
        key: "0"
      } : void 0
    ]), 1024));
  }
}), cn = { class: "text-body-2" }, Lt = /* @__PURE__ */ b({
  __name: "VoAuthGithub",
  setup(u) {
    const t = q(), s = V(() => t.user && t.findIdentity("github")), o = V(() => t.user ? s.value ? "Connected to GitHub" : "Connect GitHub" : "Login with GitHub");
    return (r, n) => (d(), v(ye, {
      "base-color": "#2a2a2a",
      "prepend-icon": "$github",
      rounded: "pill",
      slim: "",
      variant: "flat",
      onClick: n[0] || (n[0] = (l) => e(t).login("github"))
    }, Z({
      title: i(() => [
        h("span", cn, S(e(o)), 1)
      ]),
      _: 2
    }, [
      !e(t).user && e(t).lastLoginProvider() === "github" ? {
        name: "subtitle",
        fn: i(() => [
          n[1] || (n[1] = h("div", { class: "text-caption mt-n1" }, "Last Used", -1))
        ]),
        key: "0"
      } : void 0
    ]), 1024));
  }
}), dn = { class: "text-center" }, pn = { class: "text-center mb-6" }, mn = { class: "text-h6 font-weight-light" }, It = /* @__PURE__ */ b({
  __name: "VoAuthCard",
  setup(u) {
    const t = q();
    return (s, o) => {
      const r = Lt, n = St, l = Ct;
      return d(), v(E, {
        class: "pt-6 pb-8 px-4 px-sm-8 mx-auto",
        "max-width": "480"
      }, {
        default: i(() => [
          h("div", dn, [
            a(ne, {
              class: "mx-auto",
              image: "https://vuetifyjs.b-cdn.net/docs/images/avatars/one.png",
              size: "64"
            })
          ]),
          h("div", pn, [
            a(Po, { class: "text-h5 mb-1 text-md-h4" }, {
              default: i(() => [
                h("div", mn, S(e(t).lastLoginProvider() ? "Welcome back to" : "Login to"), 1),
                o[0] || (o[0] = h("span", { class: "text-h3 font-weight-bold" }, "Vuetify One", -1))
              ]),
              _: 1
            }),
            a(Ro, { class: "text-wrap" }, {
              default: i(() => o[1] || (o[1] = [
                O(" Login to save your settings and gain access to exclusive subscriber perks. ")
              ])),
              _: 1
            })
          ]),
          a(de, {
            class: "mx-auto",
            "max-width": "300",
            width: "100%"
          }, {
            default: i(() => [
              a(r, { class: "mb-3" }),
              a(n, { class: "mb-3" }),
              a(l)
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), At = /* @__PURE__ */ b({
  __name: "VoAuthDialog",
  setup(u) {
    const t = q();
    return (s, o) => {
      const r = It;
      return d(), v(tt, {
        modelValue: e(t).dialog,
        "onUpdate:modelValue": o[0] || (o[0] = (n) => e(t).dialog = n),
        "max-width": "480"
      }, {
        default: i(() => [
          a(r)
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}), qe = G("notifications", () => {
  const u = K(), t = j(), s = M([]), o = A(!1), r = V(() => s.value.filter((c) => !t.notifications.read.includes(c.slug))), n = V(() => s.value.filter((c) => t.notifications.read.includes(c.slug)));
  async function l() {
    try {
      o.value = !0;
      const c = await u.get("/one/notifications");
      s.value = c.notifications;
    } catch {
    } finally {
      o.value = !1;
    }
    return s.value;
  }
  return {
    isLoading: o,
    all: s,
    read: n,
    unread: r,
    index: l
  };
}), fn = /* @__PURE__ */ b({
  __name: "VoNotificationsTotalBadge",
  setup(u) {
    const t = q(), s = qe(), o = j(), r = V(() => o.notifications.show ? s.unread.length : 0);
    return (n, l) => (d(), v(ot, {
      color: "error",
      content: e(r),
      dot: !!e(t).user,
      location: "start top",
      "model-value": e(r) > 0
    }, {
      default: i(() => [
        B(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["content", "dot", "model-value"]));
  }
}), Ue = /* @__PURE__ */ b({
  __name: "VoBtn",
  props: {
    readonly: { type: Boolean }
  },
  setup(u) {
    const t = u;
    return (s, o) => (d(), v(z, {
      class: "text-none font-weight-regular",
      color: "primary",
      size: "small",
      style: pt({
        pointerEvents: t.readonly ? "none" : void 0
      }),
      tabindex: t.readonly ? -1 : void 0,
      variant: "flat"
    }, Z({
      loader: i(() => [
        s.$slots.loader ? x("", !0) : (d(), v(Eo, {
          key: 0,
          indeterminate: "disable-shrink",
          size: "16",
          width: "2"
        })),
        B(s.$slots, "loader")
      ]),
      _: 2
    }, [
      s.$slots.prepend ? {
        name: "prepend",
        fn: i(() => [
          B(s.$slots, "prepend")
        ]),
        key: "0"
      } : void 0,
      s.$slots.default ? {
        name: "default",
        fn: i(() => [
          B(s.$slots, "default")
        ]),
        key: "1"
      } : void 0
    ]), 1032, ["style", "tabindex"]));
  }
}), vn = { class: "pa-4 d-flex flex-column ga-4" }, Dt = /* @__PURE__ */ b({
  __name: "VoAuthListItem",
  setup(u) {
    const t = q(), s = j(), o = A(!t.user && !t.isLoading);
    R(() => t.user, (n) => {
      o.value = !n;
    });
    function r() {
      t.user && (o.value = !o.value);
    }
    return (n, l) => {
      const c = Lt, p = St, m = Ct;
      return d(), v(E, {
        class: "ma-2",
        rounded: "lg",
        variant: e(o) ? "tonal" : "text"
      }, {
        default: i(() => [
          a(de, { class: "py-0" }, {
            default: i(() => [
              a(ye, {
                class: "mb-0",
                link: !!e(t).user,
                nav: "",
                "prepend-icon": `svg:${e(t).user && e(s).syncSettings ? e(Qt) : e(Yt)}`,
                rounded: "b-0",
                slim: "",
                title: e(t).user && e(s).syncSettings ? "Sync is on" : "Sync is paused",
                onClick: r
              }, {
                append: i(() => [
                  a(Re, null, {
                    default: i(() => [
                      e(t).user && (e(o) || !e(s).syncSettings) ? (d(), v(nt, {
                        key: 0,
                        modelValue: e(s).syncSettings,
                        "onUpdate:modelValue": l[0] || (l[0] = (g) => e(s).syncSettings = g),
                        color: e(s).syncSettings ? "success" : void 0,
                        density: "compact",
                        "hide-details": "",
                        inset: "",
                        onClick: l[1] || (l[1] = Ne(() => {
                        }, ["stop"]))
                      }, {
                        thumb: i(() => [
                          a(ne, {
                            color: e(s).syncSettings ? "success" : void 0
                          }, null, 8, ["color"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "color"])) : x("", !0)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["link", "prepend-icon", "title"]),
              a(be, null, {
                default: i(() => [
                  !e(t).user && !e(t).isLoading || e(o) ? (d(), v(Pe, {
                    key: 0,
                    border: "t",
                    color: "transparent"
                  }, {
                    default: i(() => [
                      h("div", vn, [
                        a(c, {
                          onClick: l[2] || (l[2] = (g) => o.value = !1)
                        }),
                        a(p, {
                          onClick: l[3] || (l[3] = (g) => o.value = !1)
                        }),
                        a(m, {
                          onClick: l[4] || (l[4] = (g) => o.value = !1)
                        })
                      ])
                    ]),
                    _: 1
                  })) : x("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["variant"]);
    };
  }
}), ee = /* @__PURE__ */ b({
  __name: "VoListItem",
  setup(u) {
    return (t, s) => (d(), v(ye, { slim: "" }, Z({
      default: i(() => [
        B(t.$slots, "default")
      ]),
      _: 2
    }, [
      t.$slots.prepend ? {
        name: "prepend",
        fn: i(() => [
          B(t.$slots, "prepend")
        ]),
        key: "0"
      } : void 0,
      t.$slots.title ? {
        name: "title",
        fn: i(() => [
          B(t.$slots, "title")
        ]),
        key: "1"
      } : void 0,
      t.$slots.append ? {
        name: "append",
        fn: i(() => [
          B(t.$slots, "append")
        ]),
        key: "2"
      } : void 0
    ]), 1024));
  }
}), gn = /* @__PURE__ */ b({
  __name: "VoAuthLogoutNavItem",
  setup(u) {
    const t = q(), s = A(!1);
    async function o() {
      s.value = !0, await t.logout(), s.value = !1;
    }
    return (r, n) => {
      const l = ee;
      return d(), v(l, {
        class: "mb-0",
        disabled: e(s),
        link: "",
        loading: e(s),
        "prepend-icon": `svg:${e(Jt)}`,
        title: "Logout",
        onClick: o
      }, null, 8, ["disabled", "loading", "prepend-icon"]);
    };
  }
}), we = /* @__PURE__ */ b({
  __name: "VoDialog",
  props: /* @__PURE__ */ jt({
    prependIcon: {},
    title: {}
  }, {
    modelValue: { type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(u) {
    const t = ce(u, "modelValue"), s = me(), o = A(!1);
    return (r, n) => (d(), v(tt, {
      modelValue: t.value,
      "onUpdate:modelValue": n[2] || (n[2] = (l) => t.value = l),
      activator: "parent",
      fullscreen: e(o) || e(s).xs.value,
      height: "100%",
      "max-height": e(o) || e(s).xs.value ? "100%" : 800,
      "max-width": e(o) || e(s).xs.value ? "100%" : 800
    }, {
      default: i(({ isActive: l }) => [
        a(E, {
          class: "overflow-hidden",
          height: "inherit",
          "prepend-icon": r.prependIcon,
          title: r.title
        }, Z({
          append: i(() => [
            B(r.$slots, "append"),
            e(s).xs.value ? x("", !0) : (d(), v(z, {
              key: 0,
              class: "me-2",
              density: "comfortable",
              icon: `svg:${e(o) ? e(Xt) : e(Kt)}`,
              size: "small",
              variant: "text",
              onClick: n[0] || (n[0] = (c) => o.value = !e(o))
            }, null, 8, ["icon"])),
            a(z, {
              density: "comfortable",
              icon: "$close",
              size: "small",
              variant: "text",
              onClick: n[1] || (n[1] = (c) => t.value = !t.value)
            })
          ]),
          default: i(() => [
            a(J),
            B(r.$slots, "default")
          ]),
          _: 2
        }, [
          r.$slots.prepend ? {
            name: "prepend",
            fn: i(() => [
              B(r.$slots, "prepend")
            ]),
            key: "0"
          } : void 0,
          r.$slots.actions ? {
            name: "actions",
            fn: i(() => [
              B(r.$slots, "actions", { isActive: l })
            ]),
            key: "1"
          } : void 0
        ]), 1032, ["prepend-icon", "title"])
      ]),
      _: 3
    }, 8, ["modelValue", "fullscreen", "max-height", "max-width"]));
  }
}), Tt = /* @__PURE__ */ b({
  __name: "VoSwitch",
  props: {
    disabled: { type: Boolean }
  },
  setup(u) {
    return (t, s) => (d(), v(nt, {
      color: "primary",
      density: "compact",
      disabled: t.disabled,
      inset: "",
      "true-icon": `svg:${e(Ae)}`
    }, Z({
      thumb: i(() => [
        a(D, {
          color: t.disabled ? void 0 : "primary"
        }, null, 8, ["color"])
      ]),
      _: 2
    }, [
      t.$slots.label ? {
        name: "label",
        fn: i(() => [
          B(t.$slots, "label")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["disabled", "true-icon"]));
  }
}), _n = {
  key: 1,
  class: "mb-3 text-caption text-medium-emphasis"
}, ve = /* @__PURE__ */ b({
  __name: "VoDialogSubheader",
  props: {
    title: {},
    text: {}
  },
  setup(u) {
    return (t, s) => (d(), L(N, null, [
      t.title ? (d(), v(Je, {
        key: 0,
        class: "font-weight-black"
      }, {
        default: i(() => [
          O(S(t.title), 1)
        ]),
        _: 1
      })) : x("", !0),
      t.text ? (d(), L("div", _n, S(t.text), 1)) : x("", !0)
    ], 64));
  }
}), hn = { key: 0 }, yn = /* @__PURE__ */ b({
  __name: "VoSettingsPageSuitOption",
  setup(u) {
    const t = j(), s = [
      {
        title: "Choose a page suit",
        value: "",
        prependIcon: `svg:${eo}`,
        disabled: !0
      },
      {
        title: "Blackguard",
        prependIcon: `svg:${mt}`,
        value: "blackguard"
      },
      {
        title: "Polaris",
        prependIcon: `svg:${ft}`,
        value: "polaris"
      },
      {
        title: "Nebula",
        prependIcon: `svg:${vt}`,
        value: "nebula"
      },
      {
        title: "Odyssey",
        prependIcon: `svg:${gt}`,
        value: "odyssey"
      }
    ];
    return (o, r) => {
      const n = Tt, l = ve;
      return d(), L(N, null, [
        a(n, {
          modelValue: e(t).suits.show,
          "onUpdate:modelValue": r[0] || (r[0] = (c) => e(t).suits.show = c),
          class: "mb-2",
          label: "Enable Page suits",
          messages: "Customize layout elements with a unique background, styled after one of our themed releases."
        }, null, 8, ["modelValue"]),
        a(be, null, {
          default: i(() => [
            e(t).suits.show ? (d(), L("div", hn, [
              a(Zo, {
                modelValue: e(t).suits.suit,
                "onUpdate:modelValue": r[1] || (r[1] = (c) => e(t).suits.suit = c),
                clearable: "",
                density: "compact",
                "item-props": "",
                items: s,
                placeholder: "Choose a page suit",
                "single-line": "",
                style: { "max-width": "300px" },
                variant: "outlined"
              }, {
                selection: i(({ item: c }) => [
                  a(D, {
                    icon: c.props.prependIcon,
                    size: "x-small",
                    start: ""
                  }, null, 8, ["icon"]),
                  O(" " + S(c.title), 1)
                ]),
                _: 1
              }, 8, ["modelValue"]),
              a(l, { text: "Select your suit elements to display the background image:" }),
              a(Wo, {
                modelValue: e(t).suits.elements,
                "onUpdate:modelValue": r[2] || (r[2] = (c) => e(t).suits.elements = c),
                color: "primary",
                filter: "",
                multiple: ""
              }, {
                default: i(() => [
                  a(ie, {
                    "append-icon": `svg:${e(to)}`,
                    "filter-icon": "$success",
                    text: "App Bar",
                    value: "app-bar",
                    variant: "flat"
                  }, {
                    append: i(() => [
                      a(J, {
                        class: "ms-2 border-opacity-50",
                        vertical: ""
                      }),
                      a(D, { size: "x-small" })
                    ]),
                    _: 1
                  }, 8, ["append-icon"]),
                  a(ie, {
                    "append-icon": `svg:${e(oo)}`,
                    "filter-icon": "$success",
                    text: "Navigation Drawer",
                    value: "drawer",
                    variant: "flat"
                  }, {
                    append: i(() => [
                      a(J, {
                        class: "ms-2 border-opacity-50",
                        vertical: ""
                      }),
                      a(D, { size: "x-small" })
                    ]),
                    _: 1
                  }, 8, ["append-icon"]),
                  a(ie, {
                    "append-icon": "$info",
                    "filter-icon": "$success",
                    text: "Footer",
                    value: "footer",
                    variant: "flat"
                  }, {
                    append: i(() => [
                      a(J, {
                        class: "ms-2 border-opacity-50",
                        vertical: ""
                      }),
                      a(D, { size: "x-small" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])) : x("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
});
function bn() {
  return {
    blackguard: {
      dark: !0,
      colors: {
        background: "#0f0c24",
        primary: "#e7810d",
        surface: "#1e184a",
        info: "#9c27b0",
        accent: "#FF4081",
        success: "#84b38a",
        "surface-light": "#362b89",
        "surface-bright": "#564f8a",
        "surface-variant": "#6458b4",
        "on-surface-variant": "#FFFFFF",
        "primary-darken-1": "#c56e0b",
        secondary: "#8A2BE2",
        "secondary-darken-1": "#7919cb",
        error: "#FF5555",
        warning: "#ffa726"
      },
      variables: {
        "border-color": "#FFFFFF",
        "border-opacity": 0.12,
        "high-emphasis-opacity": 0.87,
        "medium-emphasis-opacity": 0.6,
        "disabled-opacity": 0.38,
        "idle-opacity": 0.1,
        "hover-opacity": 0.08,
        "focus-opacity": 0.12,
        "selected-opacity": 0.12,
        "activated-opacity": 0.12,
        "pressed-opacity": 0.16,
        "dragged-opacity": 0.08,
        "theme-kbd": "#212529",
        "theme-on-kbd": "#FFFFFF",
        "theme-code": "#343434",
        "theme-on-code": "#CCCCCC"
      }
    },
    polaris: {
      dark: !0,
      colors: {
        background: "#1f0a0d",
        primary: "#972800",
        surface: "#29110e",
        info: "#e7810d",
        accent: "#b35000",
        success: "#486a2b",
        "surface-light": "#773421",
        "surface-bright": "#ffa752",
        "surface-variant": "#924d2c",
        "on-surface-variant": "#FFFFFF",
        "primary-darken-1": "#c33100",
        secondary: "#ac1900",
        "secondary-darken-1": "#8a1600",
        error: "#ff5555",
        warning: "#ffa726"
      },
      variables: {
        "border-color": "#ffffff",
        "border-opacity": 0.12,
        "high-emphasis-opacity": 0.87,
        "medium-emphasis-opacity": 0.6,
        "disabled-opacity": 0.38,
        "idle-opacity": 0.1,
        "hover-opacity": 0.08,
        "focus-opacity": 0.12,
        "selected-opacity": 0.12,
        "activated-opacity": 0.12,
        "pressed-opacity": 0.16,
        "dragged-opacity": 0.08,
        "theme-kbd": "#212529",
        "theme-on-kbd": "#ffffff",
        "theme-code": "#343434",
        "theme-on-code": "#cccccc"
      }
    },
    nebula: {
      dark: !0,
      colors: {
        background: "#0f172a",
        primary: "#3462e3",
        surface: "#1e293b",
        info: "#64748b",
        accent: "#0ea5e9",
        success: "#14b8a6",
        "surface-light": "#2e3d59",
        "surface-bright": "#87a7ff",
        "surface-variant": "#334155",
        "on-surface-variant": "#FFFFFF",
        "primary-darken-1": "#1c2d60",
        secondary: "#0284c7",
        "secondary-darken-1": "#0369a1",
        error: "#ef4444",
        warning: "#f97316"
      },
      variables: {
        "border-color": "#ffffff",
        "border-opacity": 0.2,
        "high-emphasis-opacity": 0.87,
        "medium-emphasis-opacity": 0.6,
        "disabled-opacity": 0.38,
        "idle-opacity": 0.1,
        "hover-opacity": 0.08,
        "focus-opacity": 0.12,
        "selected-opacity": 0.12,
        "activated-opacity": 0.12,
        "pressed-opacity": 0.16,
        "dragged-opacity": 0.08,
        "theme-kbd": "#1e40af",
        "theme-on-kbd": "#dbeafe",
        "theme-code": "#0f172a",
        "theme-on-code": "#93c5fd"
      }
    },
    odyssey: {
      dark: !1,
      colors: {
        background: "#fffbe6",
        primary: "#356859",
        surface: "#fffbe6",
        info: "#37966f",
        accent: "#b9e4c9",
        success: "#5bb49a",
        "surface-light": "#95b3a0",
        "surface-bright": "#ffffff",
        "surface-variant": "#37966f",
        "primary-darken-1": "#00CC00",
        secondary: "#FD5523",
        "secondary-darken-1": "#CC3700",
        error: "#FF5555",
        warning: "#ecb85b"
      },
      variables: {
        "border-color": "#000000",
        "border-opacity": 0.24,
        "high-emphasis-opacity": 1,
        "medium-emphasis-opacity": 0.87,
        "disabled-opacity": 0.5,
        "idle-opacity": 0.1,
        "hover-opacity": 0.2,
        "focus-opacity": 0.3,
        "selected-opacity": 0.3,
        "activated-opacity": 0.3,
        "pressed-opacity": 0.4,
        "dragged-opacity": 0.2,
        "theme-kbd": "#000000",
        "theme-on-kbd": "#ffffff",
        "theme-code": "#000000",
        "theme-on-code": "#ffffff"
      }
    },
    highContrast: {
      dark: !0,
      colors: {
        background: "#000000",
        surface: "#121212",
        primary: "#ffD700",
        "primary-darken-1": "#e6c300",
        secondary: "#00ccdd",
        "secondary-darken-1": "#00e600",
        accent: "#ff00ff",
        info: "#31aaff",
        warning: "#ffaa00",
        error: "#ff0000",
        success: "#00ff00",
        "on-surface-variant": "#ffffff",
        "surface-light": "#222222",
        "surface-bright": "#000000",
        "surface-variant": "#333333"
      },
      variables: {
        "border-color": "#ffffff",
        "border-opacity": 0.87,
        "high-emphasis-opacity": 1,
        "medium-emphasis-opacity": 0.87,
        "disabled-opacity": 0.5,
        "idle-opacity": 0.1,
        "hover-opacity": 0.2,
        "focus-opacity": 0.3,
        "selected-opacity": 0.3,
        "activated-opacity": 0.3,
        "pressed-opacity": 0.4,
        "dragged-opacity": 0.2,
        "theme-kbd": "#000000",
        "theme-on-kbd": "#ffffff",
        "theme-code": "#000000",
        "theme-on-code": "#ffffff"
      }
    }
  };
}
const We = G("settings", () => {
  const u = "https://cdn.vuetifyjs.com/docs/images/one/", t = F(), s = j(), o = He(), r = bn(), n = {
    blackguard: {
      "app-bar": u + "suits/blackguard/blackguard-app-bar.png",
      drawer: u + "suits/blackguard/blackguard-app-drawer.png",
      footer: u + "suits/blackguard/blackguard-app-footer.png"
    },
    polaris: {
      "app-bar": u + "suits/polaris/polaris-app-bar.png",
      drawer: u + "suits/polaris/polaris-app-drawer.png",
      footer: u + "suits/polaris/polaris-app-footer.png"
    },
    nebula: {
      "app-bar": u + "suits/nebula/nebula-app-bar.png",
      drawer: u + "suits/nebula/nebula-app-drawer.png",
      footer: u + "suits/nebula/nebula-app-footer.png"
    },
    odyssey: {
      "app-bar": u + "suits/odyssey/odyssey-app-bar.png",
      drawer: u + "suits/odyssey/odyssey-app-drawer.png",
      footer: u + "suits/odyssey/odyssey-app-footer.png"
    }
  }, l = V(() => {
    if (!s.suits.suit || !s.suits.show || !t.isSubscriber)
      return {};
    const c = n[s.suits.suit.toLowerCase()], p = {};
    for (const m of s.suits.elements)
      p[m] = c[m];
    return p;
  });
  return o.themes.value = {
    ...o.themes.value,
    ...r
  }, R(() => s.theme, (c) => {
    c === "system" ? o.global.name.value = window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : (o.global.name.value = c, s.suits.suit = n[c] ? c : ""), s.theme = c;
  }, { immediate: !0 }), {
    suit: l,
    CDN_URL: u
  };
}), Vn = { class: "ms-5" }, kn = { class: "pb-2" }, $n = /* @__PURE__ */ b({
  __name: "VoSettingsDialog",
  props: {
    modelValue: { type: Boolean },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(u) {
    const t = ce(u, "modelValue"), s = F(), o = We(), r = j(), n = V(() => [
      {
        title: "Light",
        subtitle: "A standard light theme.",
        image: o.CDN_URL + "themes/light.png",
        prependIcon: `svg:${no}`,
        value: "light"
      },
      {
        title: "Dark",
        subtitle: "A standard dark theme.",
        image: o.CDN_URL + "themes/dark.png",
        prependIcon: `svg:${so}`,
        value: "dark"
      },
      {
        title: "System",
        subtitle: "A theme based on the system preference.",
        image: o.CDN_URL + "themes/system.png",
        prependIcon: `svg:${ao}`,
        value: "system"
      },
      {
        title: "High Contrast",
        subtitle: "A theme for high contrast.",
        image: o.CDN_URL + "themes/high-contrast.png",
        prependIcon: `svg:${io}`,
        value: "highContrast",
        disabled: !s.isSubscriber
      }
    ]), l = V(() => [
      {
        title: "Blackguard",
        subtitle: "A theme for v3.4 Blackguard.",
        image: o.CDN_URL + "themes/blackguard.png",
        prependIcon: `svg:${mt}`,
        value: "blackguard",
        disabled: !s.isSubscriber
      },
      {
        title: "Polaris",
        subtitle: "A theme for v3.5 Polaris.",
        image: o.CDN_URL + "themes/polaris.png",
        prependIcon: `svg:${ft}`,
        value: "polaris",
        disabled: !s.isSubscriber
      },
      {
        title: "Nebula",
        subtitle: "A theme for v3.6 Nebula.",
        image: o.CDN_URL + "themes/nebula.png",
        prependIcon: `svg:${vt}`,
        value: "nebula",
        disabled: !s.isSubscriber
      },
      {
        title: "Odyssey",
        subtitle: "A theme for v3.7 Odyssey.",
        image: o.CDN_URL + "themes/odyssey.png",
        prependIcon: `svg:${gt}`,
        value: "odyssey",
        disabled: !s.isSubscriber
      }
    ]), c = V(() => [
      { title: "Standard", items: n.value },
      { title: "Releases", items: l.value }
    ]), p = fe();
    R(p, async () => {
      p.value.one === "settings" && (s.isOpen = !0, await Ie(), t.value = !0);
    }, { immediate: !0 });
    function m(g, f) {
      f.disabled || (r.theme = f.value, g == null || g());
    }
    return (g, f) => {
      const C = ve, _ = yn, k = Tt, y = we;
      return d(), v(y, {
        modelValue: t.value,
        "onUpdate:modelValue": f[6] || (f[6] = ($) => t.value = $),
        "prepend-icon": `svg:${e(ro)}`,
        title: "Settings"
      }, {
        default: i(() => [
          a(Ve, null, {
            default: i(() => [
              a(ke, { scrollable: "" }, {
                default: i(() => [
                  a(ae, { class: "px-7" }, {
                    default: i(() => [
                      a(C, {
                        text: "Customize your documentation experience with light and dark themes, as well as a combination of both named.",
                        title: "Theme"
                      }),
                      a(bt, {
                        modelValue: e(r).theme,
                        "onUpdate:modelValue": f[0] || (f[0] = ($) => e(r).theme = $),
                        mandatory: ""
                      }, {
                        default: i(() => [
                          a(Te, { dense: "" }, {
                            default: i(() => [
                              (d(!0), L(N, null, re(c.value, ($, T) => (d(), v(_e, {
                                key: T,
                                class: "d-flex flex-column ga-3",
                                cols: "12",
                                md: "6"
                              }, {
                                default: i(() => [
                                  a(zo, { class: "mb-n4" }, {
                                    default: i(() => [
                                      O(S($.title), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (d(!0), L(N, null, re($.items, (U) => (d(), v(Xe, {
                                    key: U.value,
                                    value: U.value
                                  }, {
                                    default: i(({ toggle: P, isSelected: Q }) => [
                                      a(Ee, null, {
                                        default: i(({ props: W, isHovering: X }) => [
                                          a(E, Y({
                                            color: Q ? "primary" : "surface-variant",
                                            height: "76",
                                            image: U.image,
                                            "prepend-icon": U.prependIcon,
                                            readonly: U.disabled,
                                            ripple: !U.disabled,
                                            subtitle: U.disabled ? "🔓 Unlock with Vuetify One" : U.subtitle,
                                            title: U.title,
                                            variant: "tonal",
                                            ref_for: !0
                                          }, W, {
                                            onClick: (ue) => m(P, U)
                                          }), {
                                            image: i(() => [
                                              a(le, {
                                                style: pt({
                                                  filter: Q || X ? "none" : "grayscale(100%)"
                                                })
                                              }, null, 8, ["style"])
                                            ]),
                                            _: 2
                                          }, 1040, ["color", "image", "prepend-icon", "readonly", "ripple", "subtitle", "title", "onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))), 128))
                                ]),
                                _: 2
                              }, 1024))), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      e(s).isSubscriber ? (d(), L(N, { key: 0 }, [
                        a(J, { class: "mt-6 mb-4" }),
                        a(_)
                      ], 64)) : x("", !0)
                    ]),
                    _: 1
                  }),
                  a(J),
                  a(ae, { class: "px-7" }, {
                    default: i(() => [
                      a(C, {
                        text: "These options change your browsing experience within Vuetify properties",
                        title: "Experience"
                      }),
                      e(s).isSubscriber ? (d(), v(k, {
                        key: 0,
                        modelValue: e(r).disableAds,
                        "onUpdate:modelValue": f[1] || (f[1] = ($) => e(r).disableAds = $),
                        class: "mb-2",
                        label: "Disable Ads",
                        messages: "Disable traditional advertisements on all documentation pages."
                      }, null, 8, ["modelValue"])) : x("", !0),
                      a(be, null, {
                        default: i(() => [
                          he(h("div", Vn, [
                            h("div", kn, [
                              a(k, {
                                modelValue: e(r).showHouseAds,
                                "onUpdate:modelValue": f[2] || (f[2] = ($) => e(r).showHouseAds = $),
                                label: "Show House Ads",
                                messages: "These advertisements are for Vuetify products and services only."
                              }, null, 8, ["modelValue"])
                            ])
                          ], 512), [
                            [ze, e(r).disableAds]
                          ])
                        ]),
                        _: 1
                      }),
                      a(k, {
                        modelValue: e(r).quickbar,
                        "onUpdate:modelValue": f[3] || (f[3] = ($) => e(r).quickbar = $),
                        label: "Enable Quick Actions",
                        messages: "Quick actions are located on the Vuetify One user menu and provide quick access to common tasks."
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  a(J),
                  e(s).isSubscriber ? (d(), v(ae, {
                    key: 0,
                    class: "px-7"
                  }, {
                    default: i(() => [
                      a(C, {
                        text: "Vuetify will communicate with you through banners and notifications. You can disable these features here or reset your local notification cache.",
                        title: "Communication"
                      }),
                      a(k, {
                        modelValue: e(r).notifications.show,
                        "onUpdate:modelValue": f[4] || (f[4] = ($) => e(r).notifications.show = $),
                        class: "mb-2",
                        label: "Enable Notifications",
                        messages: "Notifications are short form messages that provide information about new releases, updates, and other important information."
                      }, null, 8, ["modelValue"]),
                      a(k, {
                        modelValue: e(r).notifications.banners,
                        "onUpdate:modelValue": f[5] || (f[5] = ($) => e(r).notifications.banners = $),
                        label: "Enable Banners",
                        messages: "Banners are located at the top of the screen and provide a callout for important information."
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })) : x("", !0)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "prepend-icon"]);
    };
  }
}), wn = /* @__PURE__ */ b({
  __name: "VoSettingsListItem",
  setup(u) {
    const t = A(!1);
    return (s, o) => {
      const r = $n, n = ee;
      return d(), v(n, {
        active: e(t),
        link: "",
        "prepend-icon": `svg:${e(lo)}`,
        title: "Settings"
      }, {
        default: i(() => [
          a(r, {
            modelValue: e(t),
            "onUpdate:modelValue": o[0] || (o[0] = (l) => oe(t) ? t.value = l : null)
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["active", "prepend-icon"]);
    };
  }
}), xn = { class: "text-caption" }, Cn = /* @__PURE__ */ b({
  __name: "VoSubscriptionInvoices",
  setup(u) {
    const t = De(), s = F();
    return (o, r) => {
      const n = ve;
      return d(), v(Te, null, {
        default: i(() => [
          a(_e, { cols: "12" }, {
            default: i(() => [
              a(n, {
                text: "View and download your invoice history.",
                title: "Invoice History"
              }),
              a(E, {
                border: "",
                rounded: "lg"
              }, {
                default: i(() => [
                  a(Vt, {
                    "fixed-header": "",
                    height: "450",
                    items: e(s).invoices,
                    loading: e(s).isLoading,
                    sticky: ""
                  }, {
                    "item.date": i(({ item: l }) => [
                      h("div", xn, S(e(t).format(new Date(l.date * 1e3), "fullDateWithWeekday")), 1)
                    ]),
                    "item.amount": i(({ item: l }) => [
                      O(" $" + S(l.amount / 100), 1)
                    ]),
                    "item.status": i(({ item: l }) => [
                      a(ie, {
                        border: "success sm",
                        class: "text-capitalize",
                        color: "success",
                        label: "",
                        size: "small",
                        text: l.status,
                        variant: "tonal"
                      }, null, 8, ["text"])
                    ]),
                    "item.pdf": i(({ item: l }) => [
                      a(z, {
                        href: l.pdf,
                        icon: `svg:${e(uo)}`,
                        size: "small",
                        target: "_blank",
                        variant: "text"
                      }, null, 8, ["href", "icon"])
                    ]),
                    _: 1
                  }, 8, ["items", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), Sn = { class: "d-flex align-center" }, Ln = ["textContent"], In = { class: "me-1" }, An = { class: "text-medium-emphasis text-caption" }, Dn = { class: "d-flex align-center" }, Tn = { class: "d-flex align-start justify-space-between text-caption py-2" }, Un = { class: "font-weight-bold" }, On = { class: "font-weight-bold" }, Bn = /* @__PURE__ */ b({
  __name: "VoSubscriptionStatus",
  emits: ["change:subscription"],
  setup(u, { emit: t }) {
    const s = De(), o = F(), r = t, n = V(() => {
      if (!o.info) return;
      const c = new Date(o.info.currentPeriodEnd * 1e3);
      return s.format(c, "keyboardDate");
    });
    async function l() {
      !o.interval || !o.subscriptionType || (o.isLoading = !0, o.subscribe(o.interval, o.subscriptionType));
    }
    return (c, p) => {
      const m = Ue;
      return d(), v(Te, null, {
        default: i(() => [
          a(_e, { cols: "12" }, {
            default: i(() => {
              var g, f;
              return [
                a(E, {
                  border: "",
                  flat: "",
                  "prepend-icon": "$vuetify",
                  rounded: "lg",
                  title: "Subscription Status"
                }, Z({
                  prepend: i(() => [
                    a(D, {
                      color: e(o).isSubscriber ? "success" : void 0
                    }, null, 8, ["color"])
                  ]),
                  append: i(() => {
                    var C;
                    return [
                      e(o).hasBilling && ((C = e(o).info) == null ? void 0 : C.status) === "canceled" ? (d(), v(m, {
                        key: 0,
                        class: "me-2",
                        color: "success",
                        loading: e(o).isLoading,
                        "prepend-icon": "$success",
                        text: "Activate",
                        variant: "outlined",
                        onClick: l
                      }, null, 8, ["loading"])) : x("", !0),
                      e(o).hasBilling ? (d(), v(m, {
                        key: 1,
                        loading: e(o).isLoading,
                        "prepend-icon": `svg:${e(co)}`,
                        text: "Billing",
                        onClick: e(o).manage
                      }, null, 8, ["loading", "prepend-icon", "onClick"])) : x("", !0)
                    ];
                  }),
                  _: 2
                }, [
                  e(o).info ? {
                    name: "subtitle",
                    fn: i(() => [
                      h("div", Sn, [
                        h("strong", {
                          key: "status",
                          class: "text-capitalize hidden-sm-and-down",
                          textContent: S(e(o).info.status)
                        }, null, 8, Ln),
                        e(o).info.items.length > 0 ? (d(), L(N, { key: 0 }, [
                          p[1] || (p[1] = h("span", { class: "mx-1 hidden-sm-and-down" }, "—", -1)),
                          h("span", In, [
                            O(" $" + S(e(o).info.items[0].plan.amount / 100), 1),
                            h("span", An, "/" + S(e(o).interval), 1)
                          ]),
                          a(m, {
                            size: "x-small",
                            text: "(Change Subscription)",
                            variant: "text",
                            onClick: p[0] || (p[0] = (C) => r("change:subscription"))
                          })
                        ], 64)) : x("", !0)
                      ])
                    ]),
                    key: "0"
                  } : {
                    name: "subtitle",
                    fn: i(() => [
                      h("div", Dn, [
                        a(Le, {
                          height: "16",
                          type: "ossein",
                          width: "40"
                        }),
                        p[2] || (p[2] = h("span", { class: "mx-1" }, "—", -1)),
                        a(Le, {
                          height: "16",
                          type: "ossein",
                          width: "80"
                        })
                      ])
                    ]),
                    key: "1"
                  }
                ]), 1024),
                h("div", Tn, [
                  h("div", null, [
                    ((g = e(o).info) == null ? void 0 : g.status) === "active" ? (d(), L(N, { key: 0 }, [
                      p[3] || (p[3] = O(" Your plan renews on ")),
                      h("span", Un, S(e(s).format(e(n), "fullDateWithWeekday")), 1),
                      p[4] || (p[4] = O(". "))
                    ], 64)) : (d(), L(N, { key: 1 }, [
                      p[5] || (p[5] = O(" Your plan ends on ")),
                      h("span", On, S(e(s).format((f = e(o).info) == null ? void 0 : f.currentPeriodEnd, "fullDateWithWeekday")), 1),
                      p[6] || (p[6] = O(". "))
                    ], 64))
                  ])
                ])
              ];
            }),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), Nn = ["innerHTML"], Mn = ["innerHTML"], Fn = /* @__PURE__ */ b({
  __name: "VoSubscriptionPerks",
  props: {
    type: {}
  },
  setup(u) {
    const t = [
      "Access to the Vuetify MCP server",
      "Team wide Playgrounds, Bins, and Studios",
      "Receive a special label on GitHub created issues and pull requests"
    ], s = A(!1), o = F(), r = V(() => {
      const n = [
        "Ad Free Experience on all Vuetify properties",
        'Save and share across our platforms <a href="https://play.vuetifyjs.com" target="_blank">VPlay</a>, <a href="https://bin.vuetifyjs.com" target="_blank">VBin</a>, and <a href="https://studio.vuetifyjs.com" target="_blank">VStudio</a>',
        'Pinned Navigation Items and Rail drawer in <a href="https://vuetifyjs.com/" target="_blank">Documentation</a>',
        "Customize Navigation components with Page Suits",
        "Custom Vuetify One menu avatar"
        // Broken right now
        // 'Special role in the <a href="https://discord.vuetifyjs.com/" target="_blank">Vuetify Discord</a>',
      ];
      return u.type === "team" && n.unshift("Invite up to 25 team members"), n;
    });
    return R(s, async (n) => {
      n && o.subscriptionInfo();
    }), (n, l) => {
      const c = ee;
      return d(), L(N, null, [
        a(Je, { class: "font-weight-black" }, {
          default: i(() => l[0] || (l[0] = [
            O("Perks")
          ])),
          _: 1
        }),
        l[2] || (l[2] = h("div", { class: "mb-3 text-caption text-medium-emphasis" }, " The Vuetify One subscription comes with the following perks: ", -1)),
        a(de, {
          class: "py-0",
          density: "compact",
          lines: !1,
          nav: ""
        }, {
          default: i(() => [
            (d(!0), L(N, null, re(e(r), (p, m) => (d(), v(c, {
              key: m,
              class: "mb-0",
              "prepend-icon": `svg:${e(Ae)}`
            }, {
              prepend: i(() => [
                a(D, {
                  class: "mx-n2",
                  color: "success",
                  size: "small"
                })
              ]),
              title: i(() => [
                h("div", { innerHTML: p }, null, 8, Nn)
              ]),
              _: 2
            }, 1032, ["prepend-icon"]))), 128))
          ]),
          _: 1
        }),
        l[3] || (l[3] = h("br", null, null, -1)),
        a(Je, { class: "font-weight-black" }, {
          default: i(() => l[1] || (l[1] = [
            O("Up Next")
          ])),
          _: 1
        }),
        l[4] || (l[4] = h("div", { class: "mb-3 text-caption text-medium-emphasis" }, " The following features are in development and coming soon: ", -1)),
        a(de, {
          class: "py-0",
          density: "compact",
          lines: !1,
          nav: ""
        }, {
          default: i(() => [
            (d(), L(N, null, re(t, (p, m) => a(c, {
              key: m,
              class: "mb-0",
              "prepend-icon": `svg:${e(po)}`
            }, {
              prepend: i(() => [
                a(D, {
                  class: "mx-n2",
                  size: "small"
                })
              ]),
              title: i(() => [
                h("div", { innerHTML: p }, null, 8, Mn)
              ]),
              _: 2
            }, 1032, ["prepend-icon"])), 64))
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), zn = /* @__PURE__ */ b({
  __name: "VoSubscriptionSubscribe",
  props: {
    interval: { default: "year" },
    intervalModifiers: {},
    type: { default: "solo" },
    typeModifiers: {}
  },
  emits: ["update:interval", "update:type"],
  setup(u) {
    const t = A(!1), s = ce(u, "interval"), o = ce(u, "type"), r = F(), n = $e(), l = V(() => n.hasTeamAccess && !n.isTeamOwner), c = {
      solo: {
        month: "2.99 /month",
        year: "29.99 /year"
      },
      team: {
        month: "29.99 /month",
        year: "299.99 /year"
      }
    };
    return R(t, async (p) => {
      p && r.subscriptionInfo();
    }), (p, m) => (d(), L(N, null, [
      a(bt, {
        modelValue: o.value,
        "onUpdate:modelValue": m[0] || (m[0] = (g) => o.value = g),
        class: "mb-4",
        mandatory: ""
      }, {
        default: i(() => [
          a(Te, null, {
            default: i(() => [
              a(_e, {
                cols: "12",
                md: "6"
              }, {
                default: i(() => [
                  a(Xe, { value: "solo" }, {
                    default: i(({ toggle: g, isSelected: f }) => [
                      a(E, {
                        border: f ? "sm primary opacity-50" : "sm",
                        color: f ? "primary" : void 0,
                        "prepend-icon": f ? `svg:${e(Me)}` : "$radioOff",
                        rounded: "lg",
                        subtitle: `$${c.solo[s.value]}`,
                        title: "Solo Developer",
                        variant: f ? "tonal" : "text",
                        onClick: g
                      }, {
                        prepend: i(() => [
                          a(D, { class: "mt-n6" })
                        ]),
                        _: 2
                      }, 1032, ["border", "color", "prepend-icon", "subtitle", "variant", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              a(_e, {
                cols: "12",
                md: "6"
              }, {
                default: i(() => [
                  a(Xe, { value: "team" }, {
                    default: i(({ toggle: g, isSelected: f }) => [
                      a(E, {
                        border: f ? "sm primary opacity-50" : "sm",
                        color: f ? "primary" : void 0,
                        disabled: e(l),
                        "prepend-icon": f ? `svg:${e(Me)}` : "$radioOff",
                        rounded: "lg",
                        subtitle: `$${c.team[s.value]}`,
                        title: "Team Access",
                        variant: f ? "tonal" : "text",
                        onClick: g
                      }, {
                        prepend: i(() => [
                          a(D, { class: "mt-n6" })
                        ]),
                        _: 2
                      }, 1032, ["border", "color", "disabled", "prepend-icon", "subtitle", "variant", "onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      a(nt, {
        modelValue: s.value,
        "onUpdate:modelValue": m[1] || (m[1] = (g) => s.value = g),
        "false-value": "month",
        "hide-details": "",
        inset: "",
        label: "Yearly Billing (save 20%)",
        "true-value": "year"
      }, null, 8, ["modelValue"])
    ], 64));
  }
}), jn = { class: "px-3" }, Pn = { class: "flex-grow-1 px-4 pb-3 overflow-hidden" }, Rn = /* @__PURE__ */ b({
  __name: "VoSubscriptionDialog",
  props: {
    modelValue: { type: Boolean },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(u) {
    function t(g) {
      return new Promise((f) => setTimeout(f, g));
    }
    const s = ce(u, "modelValue"), o = F(), r = fe(), n = A(o.interval), l = A(o.subscriptionType), c = A(o.hasBilling ? "status" : "subscribe"), p = A(!1);
    R([n, l], ([g, f]) => {
      !o.isSubscriber || !o.interval || !o.subscriptionType || (p.value = g !== o.interval || f !== o.subscriptionType);
    }), R(s, async (g) => {
      if (!g || !o.isSubscriber) {
        g || o.resetQuery();
        return;
      }
      o.subscriptionInfo();
    }), R(r, async () => {
      !o.sessionId && !["subscribe", "status"].includes(r.value.one) || r.value.team || (c.value = o.sessionId || r.value.one === "status" ? "status" : "subscribe", o.isOpen = !0, await Ie(), s.value = !0);
    }, { immediate: !0 }), Pt(() => {
      n.value = o.interval ?? "year", l.value = o.subscriptionType ?? "solo";
    });
    async function m() {
      await o.modify(n.value, l.value), await o.subscriptionInfo(), p.value = null, await t(3e3), c.value = "status", await t(300), p.value = !1;
    }
    return (g, f) => {
      const C = ve, _ = zn, k = Fn, y = Bn, $ = Cn, T = Ue, U = we;
      return d(), v(U, {
        modelValue: s.value,
        "onUpdate:modelValue": f[5] || (f[5] = (P) => s.value = P),
        "prepend-icon": `svg:${e(mo)}`,
        title: "Subscriptions"
      }, Z({
        default: i(() => [
          a(Ve, null, {
            default: i(() => [
              a(ke, { scrollable: "" }, {
                default: i(() => [
                  h("div", jn, [
                    a(ae, null, {
                      default: i(() => [
                        a(C, {
                          text: "The Vuetify One subscription is a great way to support the Vuetify team and get access to exclusive features and content.",
                          title: "Vuetify One"
                        }),
                        a(kt, { "model-value": e(c) }, {
                          default: i(() => [
                            a(Se, { value: "subscribe" }, {
                              default: i(() => [
                                a(_, {
                                  interval: e(n),
                                  "onUpdate:interval": f[0] || (f[0] = (P) => oe(n) ? n.value = P : null),
                                  type: e(l),
                                  "onUpdate:type": f[1] || (f[1] = (P) => oe(l) ? l.value = P : null)
                                }, null, 8, ["interval", "type"]),
                                f[6] || (f[6] = h("br", null, null, -1)),
                                a(k, { type: e(l) }, null, 8, ["type"])
                              ]),
                              _: 1
                            }),
                            a(Se, { value: "status" }, {
                              default: i(() => [
                                a(y, {
                                  "onChange:subscription": f[2] || (f[2] = (P) => c.value = "subscribe")
                                }),
                                a($)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model-value"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 2
      }, [
        e(c) === "subscribe" ? {
          name: "actions",
          fn: i(() => [
            h("div", Pn, [
              e(p) !== !1 ? (d(), v(T, {
                key: 0,
                block: "",
                color: "success",
                loading: e(o).isLoading,
                "prepend-icon": `svg:${e(p) !== null ? e(fo) : e(Me)}`,
                readonly: e(p) === null,
                size: "default",
                text: e(p) !== null ? "Modify Subscription" : "Success",
                onClick: m
              }, null, 8, ["loading", "prepend-icon", "readonly", "text"])) : e(o).one ? (d(), v(T, {
                key: 2,
                block: "",
                "prepend-icon": `svg:${e(vo)}`,
                size: "default",
                text: "Manage Subscription",
                onClick: f[4] || (f[4] = (P) => c.value = "status")
              }, null, 8, ["prepend-icon"])) : (d(), v(T, {
                key: 1,
                block: "",
                color: e(n) && e(l) ? "success" : "disabled",
                disabled: !(e(n) && e(l)),
                loading: e(o).isLoading,
                "prepend-icon": "$vuetify",
                size: "default",
                text: "Activate Subscription",
                onClick: f[3] || (f[3] = (P) => e(o).subscribe(e(n), e(l)))
              }, null, 8, ["color", "disabled", "loading"]))
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["modelValue", "prepend-icon"]);
    };
  }
}), Hn = /* @__PURE__ */ b({
  __name: "VoSubscriptionListItem",
  setup(u) {
    const t = A(!1);
    return (s, o) => {
      const r = Rn, n = ee;
      return d(), v(n, {
        active: e(t),
        link: "",
        "prepend-icon": `svg:${e(go)}`,
        title: "Subscriptions"
      }, {
        default: i(() => [
          a(r, {
            modelValue: e(t),
            "onUpdate:modelValue": o[0] || (o[0] = (l) => oe(t) ? t.value = l : null)
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["active", "prepend-icon"]);
    };
  }
}), En = {
  key: 0,
  class: "text-success"
}, at = /* @__PURE__ */ b({
  __name: "VoSponsorshipsTimelineItem",
  props: {
    title: {},
    text: {},
    href: {},
    to: {},
    logo: {},
    disabled: { type: Boolean },
    sponsorship: {}
  },
  setup(u) {
    const t = u, s = We(), o = V(() => {
      var n, l;
      return `$${Number.parseFloat(String((((n = t.sponsorship) == null ? void 0 : n.amount) ?? 0) / 100)).toFixed(2)} /${(l = t.sponsorship) == null ? void 0 : l.interval}`;
    });
    return (r, n) => {
      var c, p;
      const l = Ue;
      return d(), v(Yo, {
        "dot-color": (c = r.sponsorship) != null && c.isActive ? "success" : "transparent",
        icon: (p = r.sponsorship) != null && p.isActive ? `svg:${e(Ae)}` : void 0,
        size: "x-small",
        width: "100%"
      }, {
        default: i(() => [
          a(E, {
            border: "",
            "prepend-avatar": `${e(s).CDN_URL}logos/${r.logo}.png`,
            rounded: "lg",
            title: r.title,
            variant: "text"
          }, {
            subtitle: i(() => {
              var m;
              return [
                (m = r.sponsorship) != null && m.isActive ? (d(), L("div", En, [
                  a(D, {
                    icon: `svg:${e(_o)}`,
                    size: "x-small"
                  }, null, 8, ["icon"]),
                  O(" " + S(e(o)), 1)
                ])) : (d(), L(N, { key: 1 }, [
                  O(S(r.text), 1)
                ], 64))
              ];
            }),
            append: i(() => {
              var m, g, f, C, _, k;
              return [
                r.disabled ? (d(), v(l, {
                  key: 1,
                  color: "surface-variant",
                  readonly: "",
                  text: "Coming Soon"
                })) : (d(), v(l, {
                  key: 0,
                  active: !1,
                  color: (m = r.sponsorship) != null && m.isActive ? "success" : "primary",
                  href: (g = r.sponsorship) != null && g.isActive || r.to ? void 0 : r.href,
                  "prepend-icon": `svg:${(f = r.sponsorship) != null && f.isActive ? e(Me) : e(je)}`,
                  readonly: (C = r.sponsorship) == null ? void 0 : C.isActive,
                  target: (_ = r.sponsorship) != null && _.isActive || r.to ? void 0 : "_blank",
                  text: (k = r.sponsorship) != null && k.isActive ? "Active" : "Info",
                  to: r.to,
                  width: "88"
                }, null, 8, ["color", "href", "prepend-icon", "readonly", "target", "text", "to"]))
              ];
            }),
            _: 1
          }, 8, ["prepend-avatar", "title"])
        ]),
        _: 1
      }, 8, ["dot-color", "icon"]);
    };
  }
}), qn = /* @__PURE__ */ b({
  __name: "VoSponsorshipsTimelineItemDiscord",
  setup(u) {
    const t = F();
    return (s, o) => {
      const r = at;
      return d(), v(r, {
        href: "https://discord.com/servers/vuetify-340160225338195969",
        logo: "discord",
        sponsorship: e(t).discord,
        text: "Support Vuetify through Discord.",
        title: "Discord Subscriber"
      }, null, 8, ["sponsorship"]);
    };
  }
}), Wn = /* @__PURE__ */ b({
  __name: "VoSponsorshipsTimelineItemGithub",
  setup(u) {
    const t = F();
    return (s, o) => {
      const r = at;
      return d(), v(r, {
        href: "https://github.com/sponsors/johnleider",
        logo: "github",
        sponsorship: e(t).github,
        text: "Support Vuetify through GitHub sponsors.",
        title: "GitHub Sponsor"
      }, null, 8, ["sponsorship"]);
    };
  }
}), Zn = /* @__PURE__ */ b({
  __name: "VoSponsorshipsTimelineItemOne",
  setup(u) {
    const t = F();
    return (s, o) => {
      const r = at;
      return d(), v(r, {
        logo: "one",
        sponsorship: e(t).one,
        text: "Support Vuetify through Vuetify One.",
        title: "Vuetify One Subscriber",
        to: "?one=subscribe"
      }, null, 8, ["sponsorship"]);
    };
  }
}), Gn = /* @__PURE__ */ b({
  __name: "VoSponsorshipsTimeline",
  setup(u) {
    return (t, s) => {
      const o = Zn, r = Wn, n = qn;
      return d(), v(Jo, {
        class: "justify-start ms-n7",
        "line-inset": "12",
        side: "end",
        style: { "grid-template-columns": "auto auto 1fr" },
        "truncate-line": "both"
      }, {
        default: i(() => [
          a(o),
          a(r),
          a(n)
        ]),
        _: 1
      });
    };
  }
}), Qn = { class: "px-3 pb-5 d-flex flex-column h-100" }, Yn = { class: "font-weight-black" }, Jn = { class: "text-caption text-medium-emphasis" }, Xn = /* @__PURE__ */ b({
  __name: "VoSponsorshipsDialog",
  props: {
    modelValue: { type: Boolean },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(u) {
    const t = ce(u, "modelValue"), s = fe(), o = F();
    return R(s, async () => {
      s.value.one === "sponsorships" && (o.isOpen = !0, await Ie(), t.value = !0);
    }, { immediate: !0 }), (r, n) => {
      const l = ve, c = Gn, p = we;
      return d(), v(p, {
        modelValue: t.value,
        "onUpdate:modelValue": n[0] || (n[0] = (m) => t.value = m),
        "prepend-icon": `svg:${e(ho)}`,
        title: "Sponsorships"
      }, {
        default: i(() => [
          a(Ve, null, {
            default: i(() => [
              a(ke, { scrollable: "" }, {
                default: i(() => [
                  h("div", Qn, [
                    a(ae, { class: "flex-0-0 mb-16 mb-sm-4" }, {
                      default: i(() => [
                        a(l, {
                          text: "Support Vuetify through GitHub Sponsors or Discord to unlock exclusive benefits and content.",
                          title: "Support Vuetify"
                        }),
                        a(c)
                      ]),
                      _: 1
                    }),
                    a(st, {
                      class: "flex-1-0",
                      icon: "$vuetify",
                      "min-height": "auto",
                      size: "128"
                    }, {
                      media: i(() => [
                        a(D, {
                          color: e(o).isSubscriber ? "success" : "error"
                        }, null, 8, ["color"])
                      ]),
                      title: i(() => [
                        n[1] || (n[1] = O(" One Status: ")),
                        h("span", Yn, S(e(o).isSubscriber ? "Active" : "Inactive"), 1)
                      ]),
                      text: i(() => [
                        h("div", Jn, S(e(o).isSubscriber ? "You are currently receiving benefits of Vuetify One." : "Login to activate Vuetify One benefits"), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "prepend-icon"]);
    };
  }
}), Kn = /* @__PURE__ */ b({
  __name: "VoSponsorshipsListItem",
  setup(u) {
    const t = A(!1);
    return (s, o) => {
      const r = Xn, n = ee;
      return d(), v(n, {
        active: e(t),
        link: "",
        "prepend-icon": `svg:${e(yo)}`,
        title: "Sponsorships"
      }, {
        default: i(() => [
          a(r, {
            modelValue: e(t),
            "onUpdate:modelValue": o[0] || (o[0] = (l) => oe(t) ? t.value = l : null)
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["active", "prepend-icon"]);
    };
  }
}), es = G("downloads", () => {
  const u = K(), t = M([]), s = A(!1);
  async function o() {
    if (t.value.length > 0)
      return t.value;
    s.value = !0;
    try {
      const r = await u.get("/one/sendowl/downloads");
      t.value = r.downloads;
    } catch {
    } finally {
      s.value = !1;
    }
    return t.value;
  }
  return {
    all: t,
    isLoading: s,
    index: o
  };
}), ts = /* @__PURE__ */ b({
  __name: "VoDownloadsTable",
  setup(u) {
    const t = De(), s = es(), o = [
      {
        title: "Order ID",
        value: "order_name"
      },
      {
        title: "Items",
        value: "download_items"
      },
      {
        title: "Order date",
        value: "created_at",
        align: "end"
      },
      {
        title: "Download",
        align: "end",
        value: "download_url"
      }
    ];
    return Fe(async () => {
      await s.index();
    }), (r, n) => {
      const l = ve;
      return d(), v(Te, null, {
        default: i(() => [
          a(_e, { cols: "12" }, {
            default: i(() => [
              a(l, {
                text: "View and download your store purchases.",
                title: "Download history"
              }),
              a(E, {
                border: "",
                flat: "",
                rounded: "lg"
              }, {
                default: i(() => [
                  a(Vt, {
                    "fixed-header": "",
                    headers: o,
                    height: "640",
                    items: e(s).all,
                    loading: e(s).isLoading
                  }, {
                    "item.order_name": i(({ item: c }) => [
                      O(" #" + S(c.order_name), 1)
                    ]),
                    "item.created_at": i(({ item: c }) => [
                      O(S(e(t).format(c.created_at, "shortDate")), 1)
                    ]),
                    "item.download_items": i(({ item: c }) => [
                      (d(!0), L(N, null, re(c.download_items, (p, m) => (d(), L("div", {
                        key: m,
                        class: "text-truncate"
                      }, S(p.name), 1))), 128))
                    ]),
                    "item.download_url": i(({ item: c }) => [
                      a(z, {
                        color: "medium-emphasis",
                        href: c.download_url,
                        icon: `svg:${e(bo)}`,
                        size: "small",
                        target: "_blank",
                        variant: "text"
                      }, null, 8, ["href", "icon"])
                    ]),
                    _: 1
                  }, 8, ["items", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      });
    };
  }
}), os = { class: "px-3" }, ns = /* @__PURE__ */ b({
  __name: "VoDownloadsNavItem",
  setup(u) {
    const t = A(!1);
    return (s, o) => {
      const r = ts, n = we, l = ee;
      return d(), v(l, {
        active: e(t),
        link: "",
        "prepend-icon": `svg:${e(ut)}`,
        title: "Downloads"
      }, {
        default: i(() => [
          a(n, {
            modelValue: e(t),
            "onUpdate:modelValue": o[0] || (o[0] = (c) => oe(t) ? t.value = c : null),
            "prepend-icon": `svg:${e(ut)}`,
            title: "Downloads"
          }, {
            default: i(() => [
              a(Ve, null, {
                default: i(() => [
                  a(ke, { scrollable: "" }, {
                    default: i(() => [
                      h("div", os, [
                        a(ae, null, {
                          default: i(() => [
                            a(r)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "prepend-icon"])
        ]),
        _: 1
      }, 8, ["active", "prepend-icon"]);
    };
  }
}), ss = { class: "px-3" }, as = { class: "d-flex align-center" }, is = { class: "d-flex align-center" }, rs = /* @__PURE__ */ b({
  __name: "VoTeamDialog",
  props: {
    modelValue: { type: Boolean },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(u) {
    const t = F(), s = $e(), o = K(), r = V(() => s.team), n = fe(), l = A(!1), c = A(!1), p = [
      {
        title: "Name",
        key: "name"
      },
      {
        title: "Actions",
        key: "actions",
        align: "end",
        sortable: !1
      }
    ], m = V(() => {
      var _;
      return `https://one.vuetifyjs.com/?invite=${(_ = s.team) == null ? void 0 : _.inviteCode}`;
    }), g = ce(u, "modelValue");
    function f() {
      l.value = !0, navigator.clipboard.writeText(m.value), setTimeout(() => {
        l.value = !1;
      }, 2e3);
    }
    async function C() {
      c.value = !0;
      const _ = await o.post("/one/team/regen");
      s.team = _.team;
    }
    return R(n, async () => {
      !t.sessionId || n.value.one === "subscribe" || n.value.team && (t.isOpen = !0, await Ie(), g.value = !0);
    }, { immediate: !0 }), (_, k) => {
      const y = ve, $ = we;
      return d(), v($, {
        modelValue: g.value,
        "onUpdate:modelValue": k[1] || (k[1] = (T) => g.value = T),
        "prepend-icon": `svg:${e(Vo)}`,
        title: "Team"
      }, {
        default: i(() => [
          a(Ve, null, {
            default: i(() => [
              a(ke, { scrollable: "" }, {
                default: i(() => [
                  h("div", ss, [
                    a(ae, null, {
                      default: i(() => [
                        a(y, {
                          text: "Share access to Vuetify One with up to 25 team members.",
                          title: "Manage your team"
                        }),
                        e(s).isTeamOwner ? (d(), v(E, {
                          key: 0,
                          border: "",
                          class: "mb-4",
                          color: "surface-light",
                          flat: "",
                          "max-width": "1280",
                          rounded: "lg"
                        }, {
                          default: i(() => {
                            var T, U;
                            return [
                              a(Qe, {
                                class: "bg-surface",
                                subtitle: `Team - ${(U = (T = e(r)) == null ? void 0 : T.members) == null ? void 0 : U.length} member(s)`,
                                title: "Members"
                              }, Z({ _: 2 }, [
                                e(s).isTeamOwner ? {
                                  name: "append",
                                  fn: i(() => [
                                    a(z, {
                                      border: "",
                                      class: "text-none",
                                      color: "primary",
                                      "prepend-icon": `svg:${e(ko)}`,
                                      rounded: "lg",
                                      variant: "flat"
                                    }, {
                                      default: i(() => [
                                        k[2] || (k[2] = O(" Add member ")),
                                        a($t, {
                                          activator: "parent",
                                          "close-on-content-click": !1,
                                          location: "bottom end",
                                          "max-width": "450",
                                          offset: "8",
                                          width: "100%"
                                        }, {
                                          default: i(() => [
                                            a(E, { color: "surface-light" }, {
                                              default: i(() => [
                                                a(Qe, {
                                                  class: "bg-surface",
                                                  "prepend-icon": `svg:${e($o)}`,
                                                  subtitle: "Provide this link to invite your team members",
                                                  title: "Member invite link"
                                                }, {
                                                  append: i(() => [
                                                    a(z, {
                                                      class: "text-none",
                                                      color: e(c) ? void 0 : "error",
                                                      disabled: e(c),
                                                      flat: "",
                                                      slim: "",
                                                      text: "Reset",
                                                      onClick: C
                                                    }, null, 8, ["color", "disabled"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["prepend-icon"]),
                                                a(ae, { class: "pt-4" }, {
                                                  default: i(() => [
                                                    a(Xo, {
                                                      flat: "",
                                                      "hide-details": "",
                                                      label: "Invite link",
                                                      "model-value": e(m),
                                                      readonly: "",
                                                      variant: "solo"
                                                    }, {
                                                      "append-inner": i(() => [
                                                        he(a(D, {
                                                          icon: `svg:${e(l) ? e(Ae) : e(wo)}`,
                                                          size: "small",
                                                          onClick: f
                                                        }, null, 8, ["icon"]), [
                                                          [Ko, "Copy Team link"]
                                                        ])
                                                      ]),
                                                      _: 1
                                                    }, 8, ["model-value"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["prepend-icon"])
                                  ]),
                                  key: "0"
                                } : void 0
                              ]), 1032, ["subtitle"]),
                              a(J),
                              a(ae, { class: "pa-2" }, {
                                default: i(() => [
                                  a(Pe, {
                                    border: "",
                                    rounded: "lg"
                                  }, {
                                    default: i(() => {
                                      var P, Q, W;
                                      return [
                                        a(Qo, {
                                          headers: p,
                                          "hide-default-footer": ((Q = (P = e(r)) == null ? void 0 : P.members) == null ? void 0 : Q.length) < 10,
                                          items: (W = e(r)) == null ? void 0 : W.members
                                        }, {
                                          "item.name": i(({ item: X }) => [
                                            h("div", as, [
                                              a(ne, {
                                                image: X.picture,
                                                size: "x-small",
                                                start: ""
                                              }, null, 8, ["image"]),
                                              h("span", null, S(X.name), 1)
                                            ])
                                          ]),
                                          "item.actions": i(({ item: X }) => {
                                            var ue, pe;
                                            return [
                                              ((pe = (ue = e(r)) == null ? void 0 : ue.owner) == null ? void 0 : pe.id) === X.id ? (d(), v(z, {
                                                key: 0,
                                                class: "me-n3",
                                                color: "primary",
                                                density: "comfortable",
                                                "prepend-icon": `svg:${e(ct)}`,
                                                readonly: "",
                                                slim: "",
                                                text: "Team owner",
                                                variant: "tonal"
                                              }, null, 8, ["prepend-icon"])) : (d(), v(z, {
                                                key: 1,
                                                class: "me-n3",
                                                color: "medium-emphasis",
                                                density: "comfortable",
                                                "prepend-icon": `svg:${e(xo)}`,
                                                slim: "",
                                                text: "Revoke",
                                                variant: "text",
                                                onClick: (ge) => e(s).removeFromTeam(X.id)
                                              }, null, 8, ["prepend-icon", "onClick"]))
                                            ];
                                          }),
                                          _: 1
                                        }, 8, ["hide-default-footer", "items"])
                                      ];
                                    }),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ];
                          }),
                          _: 1
                        })) : (d(), v(E, {
                          key: 1,
                          border: "",
                          color: "surface-light",
                          flat: "",
                          "max-width": "1280",
                          rounded: "lg"
                        }, {
                          default: i(() => [
                            a(Qe, {
                              "prepend-icon": `svg:${e(ct)}`,
                              subtitle: "You are currently a member of a team with an All-access Pass.",
                              title: "My Team access"
                            }, {
                              title: i(() => [
                                h("div", is, [
                                  k[3] || (k[3] = O(" My Team Access ")),
                                  a(ie, {
                                    border: "thin opacity-25 success",
                                    class: "ms-2",
                                    color: "success",
                                    label: "",
                                    size: "x-small",
                                    text: "Active"
                                  })
                                ])
                              ]),
                              append: i(() => [
                                a(z, {
                                  "prepend-icon": `svg:${e(Co)}`,
                                  rounded: "lg",
                                  text: "Leave team",
                                  width: "145",
                                  onClick: k[0] || (k[0] = (T) => e(s).leaveTeam())
                                }, null, 8, ["prepend-icon"])
                              ]),
                              _: 1
                            }, 8, ["prepend-icon"])
                          ]),
                          _: 1
                        }))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "prepend-icon"]);
    };
  }
}), ls = /* @__PURE__ */ b({
  __name: "VoTeamListItem",
  setup(u) {
    const t = A(!1);
    return (s, o) => {
      const r = rs, n = ee;
      return d(), v(n, {
        active: e(t),
        link: "",
        "prepend-icon": `svg:${e(So)}`,
        title: "My Team"
      }, {
        default: i(() => [
          a(r, {
            modelValue: e(t),
            "onUpdate:modelValue": o[0] || (o[0] = (l) => oe(t) ? t.value = l : null)
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["active", "prepend-icon"]);
    };
  }
}), us = /* @__PURE__ */ b({
  __name: "VoStudioNavItem",
  setup(u) {
    const t = A(!1);
    return (s, o) => {
      const r = ee;
      return d(), v(r, {
        active: e(t),
        href: "https://studio.vuetifyjs.com/",
        link: "",
        "prepend-icon": "$vuetify-studio",
        target: "_blank",
        title: "Vuetify Studio"
      }, {
        append: i(() => [
          a(ie, {
            color: "amber-darken-1",
            label: "",
            size: "x-small",
            variant: "outlined"
          }, {
            default: i(() => o[0] || (o[0] = [
              O("Closed Alpha")
            ])),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["active"]);
    };
  }
}), it = G("site", () => {
  const u = M([]), t = M();
  return {
    id: u,
    url: t
  };
}), cs = {
  key: 0,
  class: "pt-16"
}, ds = {
  key: 1,
  class: "pa-5"
}, ps = { class: "text-subtitle-1 font-weight-bold" }, ms = { class: "text-caption font-weight-bold text-medium-emphasis" }, fs = { class: "text-disabled text-caption mt-2 mb-3" }, vs = /* @__PURE__ */ b({
  __name: "VoNotificationsBannerList",
  props: {
    items: {}
  },
  setup(u) {
    const t = De(), s = me(), o = j(), r = it();
    function n(c) {
      return o.notifications.last.banner.includes(c);
    }
    function l(c) {
      n(c.slug) ? o.notifications.last.banner = o.notifications.last.banner.filter((p) => p !== c.slug) : o.notifications.last.banner.push(c.slug);
    }
    return (c, p) => (d(), v(de, {
      class: "py-0",
      height: "100%",
      lines: "three"
    }, {
      default: i(() => [
        c.items.length === 0 ? (d(), L("div", cs, [
          a(st, {
            icon: "$vuetify",
            size: "256"
          }, {
            media: i(() => [
              a(D, { color: "medium-emphasis" })
            ]),
            title: i(() => p[0] || (p[0] = [
              h("div", { class: "text-medium-emphasis" }, " All caught up ", -1)
            ])),
            _: 1
          })
        ])) : (d(), L("div", ds, [
          (d(!0), L(N, null, re(c.items, (m) => {
            var g;
            return d(), L("div", {
              key: m.slug,
              class: "mb-4"
            }, [
              a(E, {
                color: m.metadata.color,
                flat: "",
                image: (g = m.metadata.images.bg) == null ? void 0 : g.url,
                rounded: "b-0",
                title: m.title
              }, {
                prepend: i(() => {
                  var f;
                  return [
                    a(ne, {
                      image: (f = m.metadata.images.logo) == null ? void 0 : f.url
                    }, null, 8, ["image"])
                  ];
                }),
                image: i(() => [
                  a(le, { position: "right" })
                ]),
                _: 2
              }, 1032, ["color", "image", "title"]),
              a(Ee, null, {
                default: i(({ props: f, isHovering: C }) => [
                  a(Pe, Y({ ref_for: !0 }, f, {
                    border: "",
                    class: "px-8 pt-2 pb-4 position-relative",
                    rounded: "b"
                  }), {
                    default: i(() => [
                      m.metadata.site.some((_) => e(r).id.includes(_)) ? (d(), v(se, {
                        key: 0,
                        location: "bottom",
                        text: n(m.slug) ? "Mark as unread" : "Mark as read"
                      }, {
                        activator: i(({ props: _ }) => [
                          a(Re, { "hide-on-leave": "" }, {
                            default: i(() => [
                              he(a(z, Y({ ref_for: !0 }, _, {
                                class: "ms-auto float-right",
                                icon: `svg:${n(m.slug) ? e(ht) : e(_t)}`,
                                "mdi-email-variant": "",
                                size: "small",
                                variant: "text",
                                onClick: (k) => l(m)
                              }), null, 16, ["icon", "onClick"]), [
                                [ze, C || e(s).mobile.value]
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["text"])) : x("", !0),
                      h("div", ps, S(m.metadata.text), 1),
                      h("div", ms, S(e(t).format(m.created_at, "fullDateWithWeekday")), 1),
                      h("div", fs, S(m.metadata.subtext), 1),
                      a(ie, Y({ ref_for: !0 }, {
                        href: m.metadata.link.startsWith("http") ? m.metadata.link : void 0,
                        target: m.metadata.link.startsWith("http") ? "_blank" : void 0,
                        to: m.metadata.link.startsWith("http") ? void 0 : m.metadata.link
                      }, {
                        "append-icon": `svg:${e(je)}`,
                        border: "",
                        label: "",
                        size: "small",
                        text: m.metadata.link_text,
                        variant: "text"
                      }), {
                        append: i(() => [
                          a(D, { size: "12" })
                        ]),
                        _: 2
                      }, 1040, ["append-icon", "text"])
                    ]),
                    _: 2
                  }, 1040)
                ]),
                _: 2
              }, 1024)
            ]);
          }), 128))
        ]))
      ]),
      _: 1
    }));
  }
}), gs = { class: "ps-3 text-subtitle-2 pe-2" }, _s = { class: "text-truncate" }, hs = { class: "text-caption font-weight-bold text-medium-emphasis" }, ys = { class: "text-disabled text-caption my-2" }, bs = /* @__PURE__ */ b({
  __name: "VoNotificationsListItem",
  props: {
    demo: { type: Boolean },
    notification: {}
  },
  setup(u) {
    const t = u, s = j(), o = De(), r = me(), n = V(() => {
      const p = t.notification.metadata ?? { action: "" };
      return {
        href: p.action.startsWith("http") ? p.action : void 0,
        target: p.action.startsWith("http") ? "_blank" : void 0,
        to: p.action.startsWith("http") ? void 0 : p.action,
        ...t.notification.metadata.attributes,
        onClick() {
          t.demo || s.notifications.read.includes(t.notification.slug) || s.notifications.read.push(t.notification.slug);
        }
      };
    });
    function l(p) {
      return s.notifications.read.includes(p);
    }
    function c(p) {
      t.demo || (l(p.slug) ? s.notifications.read = s.notifications.read.filter((m) => m !== p.slug) : s.notifications.read.push(p.slug));
    }
    return (p, m) => {
      const g = ee;
      return d(), v(Ee, null, {
        default: i(({ isHovering: f, props: C }) => [
          a(g, Y(C, { class: "py-4 mb-0" }), {
            prepend: i(() => [
              h("div", gs, S(p.notification.metadata.emoji), 1)
            ]),
            append: i(() => [
              a(tn, {
                class: "mt-n3",
                width: "56"
              }, {
                default: i(() => [
                  a(se, {
                    location: "bottom",
                    text: l(p.notification.slug) ? "Mark as unread" : "Mark as read"
                  }, {
                    activator: i(({ props: _ }) => [
                      a(Re, { "hide-on-leave": "" }, {
                        default: i(() => [
                          he(a(z, Y(_, {
                            class: "ms-auto",
                            icon: `svg:${l(p.notification.slug) ? e(ht) : e(_t)}`,
                            "mdi-email-variant": "",
                            size: "small",
                            variant: "text",
                            onClick: m[0] || (m[0] = (k) => c(p.notification))
                          }), null, 16, ["icon"]), [
                            [ze, f || e(r).mobile.value]
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["text"])
                ]),
                _: 2
              }, 1024)
            ]),
            default: i(() => [
              a(yt, { class: "text-wrap text-h6 mb-1" }, {
                default: i(() => [
                  h("div", _s, S(p.notification.title), 1)
                ]),
                _: 1
              }),
              h("div", hs, S(e(o).format(p.notification.created_at, "fullDateWithWeekday")), 1),
              h("div", ys, S(p.notification.metadata.text), 1),
              a(ie, Y({
                "append-icon": `svg:${e(je)}`
              }, e(n), {
                border: "",
                label: "",
                size: "small",
                text: p.notification.metadata.action_text,
                variant: "text"
              }), {
                append: i(() => [
                  a(D, { size: "12" })
                ]),
                _: 1
              }, 16, ["append-icon", "text"])
            ]),
            _: 2
          }, 1040)
        ]),
        _: 1
      });
    };
  }
}), Vs = {
  key: 0,
  class: "pt-16"
}, ks = /* @__PURE__ */ b({
  __name: "VoNotificationsList",
  props: {
    items: {}
  },
  setup(u) {
    return (t, s) => {
      const o = bs;
      return d(), v(de, {
        class: "py-0",
        height: "100%",
        lines: "three"
      }, {
        default: i(() => [
          t.items.length === 0 ? (d(), L("div", Vs, [
            a(st, {
              icon: "$vuetify",
              size: "256"
            }, {
              media: i(() => [
                a(D, { color: "medium-emphasis" })
              ]),
              title: i(() => s[0] || (s[0] = [
                h("div", { class: "text-medium-emphasis" }, " All caught up ", -1)
              ])),
              _: 1
            })
          ])) : (d(!0), L(N, { key: 1 }, re(t.items, (r, n) => (d(), L(N, {
            key: r.slug
          }, [
            n !== 0 ? (d(), v(J, { key: 0 })) : x("", !0),
            a(o, { notification: r }, null, 8, ["notification"])
          ], 64))), 128))
        ]),
        _: 1
      });
    };
  }
}), Ze = G("banners", () => {
  const u = K(), t = it(), s = j(), o = M([]), r = A(!1), n = V(() => {
    if (l.value)
      return l.value;
    if (s.notifications.banners)
      return o.value.find(({
        slug: p,
        metadata: {
          site: m,
          active: g
        }
      }) => !g || s.notifications.last.banner.includes(p) ? !1 : m.includes("dev") && !1 || m.includes("*") ? !0 : m.some((f) => t.id.includes(f)));
  }), l = V(() => o.value.find(({
    metadata: {
      site: p,
      active: m
    }
  }) => m ? p.includes("server") : !1));
  async function c() {
    try {
      r.value = !0;
      const p = await u.get("/one/banners");
      o.value = p.banners;
    } catch {
    } finally {
      r.value = !1;
    }
    return o.value;
  }
  return {
    all: o,
    isLoading: r,
    server: l,
    banner: n,
    index: c
  };
}), $s = { class: "text-caption" }, ws = { class: "text-caption" }, xs = /* @__PURE__ */ b({
  __name: "VoNotificationsDialog",
  props: {
    modelValue: { type: Boolean },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(u) {
    const t = me(), s = fe(), o = Ze(), r = qe(), n = F(), l = j(), c = A(["read"]), p = ce(u, "modelValue");
    return R(s, async () => {
      if (s.value.one !== "notifications") {
        p.value && (p.value = !1);
        return;
      }
      n.isOpen = !0, await Ie(), p.value = !0;
    }, { immediate: !0 }), (m, g) => {
      const f = ee, C = ks, _ = vs, k = we;
      return d(), v(k, {
        modelValue: p.value,
        "onUpdate:modelValue": g[2] || (g[2] = (y) => p.value = y),
        "prepend-icon": `svg:${e(Lo)}`,
        title: "Notifications"
      }, {
        default: i(() => [
          a(Ve, null, {
            default: i(() => [
              a(on, {
                location: e(t).mobile.value ? "top" : "start",
                permanent: "",
                width: e(t).mobile.value ? 128 : 168
              }, {
                default: i(() => [
                  a(de, {
                    selected: e(c),
                    "onUpdate:selected": g[0] || (g[0] = (y) => oe(c) ? c.value = y : null),
                    class: "px-4 pt-4",
                    density: "compact",
                    mandatory: "",
                    nav: ""
                  }, {
                    default: i(() => [
                      a(f, {
                        "prepend-icon": `svg:${e(Io)}`,
                        title: "Unread",
                        value: "read"
                      }, Z({ _: 2 }, [
                        e(r).unread.length > 0 ? {
                          name: "append",
                          fn: i(() => [
                            h("span", $s, S(e(r).unread.length), 1)
                          ]),
                          key: "0"
                        } : void 0
                      ]), 1032, ["prepend-icon"]),
                      a(f, {
                        "prepend-icon": `svg:${e(Ao)}`,
                        title: "Read",
                        value: "unread"
                      }, Z({ _: 2 }, [
                        e(r).read.length > 0 ? {
                          name: "append",
                          fn: i(() => [
                            h("span", ws, S(e(r).read.length), 1)
                          ]),
                          key: "0"
                        } : void 0
                      ]), 1032, ["prepend-icon"]),
                      e(o).all.length > 0 && e(l).notifications.banners ? (d(), v(f, {
                        key: 0,
                        "prepend-icon": `svg:${e(Do)}`,
                        title: "Banners",
                        value: "banners"
                      }, {
                        append: i(() => [
                          a(ot, {
                            dot: "",
                            "offset-y": "-3"
                          })
                        ]),
                        _: 1
                      }, 8, ["prepend-icon"])) : x("", !0)
                    ]),
                    _: 1
                  }, 8, ["selected"])
                ]),
                _: 1
              }, 8, ["location", "width"]),
              a(ke, { scrollable: "" }, {
                default: i(() => [
                  a(kt, {
                    modelValue: e(c),
                    "onUpdate:modelValue": g[1] || (g[1] = (y) => oe(c) ? c.value = y : null)
                  }, {
                    default: i(() => [
                      a(Se, { value: "read" }, {
                        default: i(() => [
                          a(C, {
                            items: e(r).unread
                          }, null, 8, ["items"])
                        ]),
                        _: 1
                      }),
                      a(Se, { value: "unread" }, {
                        default: i(() => [
                          a(C, {
                            items: e(r).read
                          }, null, 8, ["items"])
                        ]),
                        _: 1
                      }),
                      a(Se, { value: "banners" }, {
                        default: i(() => [
                          a(_, {
                            items: e(o).all
                          }, null, 8, ["items"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "prepend-icon"]);
    };
  }
}), Cs = /* @__PURE__ */ b({
  __name: "VoNotificationsBadge",
  setup(u) {
    const t = qe(), s = j();
    return (o, r) => (d(), v(ot, {
      color: "error",
      content: e(t).unread.length,
      "model-value": e(s).notifications.show && e(t).unread.length > 0
    }, {
      default: i(() => [
        B(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["content", "model-value"]));
  }
}), Ss = /* @__PURE__ */ b({
  __name: "VoNotificationsNavItem",
  setup(u) {
    const t = Ze(), s = j(), o = qe(), r = A(!1);
    return Fe(async () => {
      o.index(), t.index();
    }), (n, l) => {
      const c = Cs, p = xs, m = ee;
      return e(s).notifications.show ? (d(), v(m, {
        key: 0,
        active: e(r),
        link: "",
        "prepend-icon": `svg:${e(To)}`,
        title: "Notifications"
      }, Z({
        default: i(() => [
          a(p, {
            modelValue: e(r),
            "onUpdate:modelValue": l[0] || (l[0] = (g) => oe(r) ? r.value = g : null)
          }, null, 8, ["modelValue"])
        ]),
        _: 2
      }, [
        e(o).unread.length > 0 ? {
          name: "prepend",
          fn: i(() => [
            a(c, null, {
              default: i(() => [
                a(D)
              ]),
              _: 1
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["active", "prepend-icon"])) : x("", !0);
    };
  }
}), Ls = /* @__PURE__ */ b({
  __name: "VoDashboardNavItem",
  setup(u) {
    const t = F();
    function s() {
      setTimeout(() => {
        t.isOpen = !1;
      }, 100);
    }
    return (o, r) => {
      const n = ee;
      return d(), v(n, {
        "prepend-icon": `svg:${e(Uo)}`,
        title: "Dashboard",
        to: "/user/dashboard",
        onClick: s
      }, null, 8, ["prepend-icon"]);
    };
  }
}), Is = /* @__PURE__ */ b({
  __name: "VoUserList",
  setup(u) {
    const t = q(), s = F(), o = $e();
    return (r, n) => {
      const l = Ls, c = Ss, p = us, m = ls, g = ns, f = Kn, C = Hn, _ = wn, k = gn;
      return d(), v(de, {
        density: "compact",
        nav: "",
        slim: ""
      }, {
        default: i(() => [
          e(t).user ? (d(), v(l, { key: 0 })) : x("", !0),
          a(c),
          a(p),
          e(o).hasTeamAccess ? (d(), v(m, { key: 1 })) : x("", !0),
          e(s).shopify ? (d(), v(g, { key: 2 })) : x("", !0),
          a(f),
          e(t).user ? (d(), v(C, { key: 3 })) : x("", !0),
          a(_),
          e(t).user ? (d(), v(k, { key: 4 })) : x("", !0)
        ]),
        _: 1
      });
    };
  }
}), Ut = /* @__PURE__ */ b({
  __name: "VoIconIssues",
  setup(u) {
    const t = [
      ["M21.57 19.41L18.36 16.41C19.7242 14.5916 20.3549 12.3267 20.127 10.065C19.8991 7.80316 18.8293 5.70969 17.1298 4.19992C15.4303 2.69016 13.2254 1.87444 10.9525 1.91463C8.67959 1.95481 6.50486 2.84796 4.8598 4.41685C3.21475 5.98575 2.21959 8.11573 2.07179 10.3842C1.924 12.6526 2.63436 14.8937 4.06193 16.6628C5.4895 18.4319 7.52995 19.5997 9.77841 19.9344C12.0269 20.2692 14.319 19.7465 16.2 18.47L19.5 21.6C19.7743 21.8507 20.1287 21.996 20.5 22.01C20.7053 22.0117 20.9087 21.9698 21.0966 21.8871C21.2845 21.8043 21.4527 21.6826 21.59 21.53C21.729 21.3901 21.8389 21.224 21.9132 21.0413C21.9875 20.8586 22.0248 20.663 22.0229 20.4658C22.0211 20.2686 21.9801 20.0737 21.9023 19.8925C21.8246 19.7113 21.7116 19.5473 21.57 19.41ZM11.1 17.33C9.83508 17.328 8.59909 16.9512 7.54815 16.2472C6.49721 15.5432 5.67846 14.5436 5.1953 13.3746C4.71214 12.2055 4.58624 10.9195 4.8335 9.67898C5.08077 8.43843 5.6901 7.29898 6.58455 6.40453C7.47901 5.51007 8.61846 4.90074 9.85901 4.65347C11.0996 4.40621 12.3856 4.53211 13.5546 5.01527C14.7236 5.49843 15.7233 6.31718 16.4273 7.36812C17.1313 8.41906 17.5081 9.65506 17.51 10.92C17.51 11.7618 17.3442 12.5953 17.0221 13.373C16.7 14.1507 16.2278 14.8573 15.6326 15.4526C15.0374 16.0478 14.3307 16.5199 13.553 16.8421C12.7753 17.1642 11.9418 17.33 11.1 17.33Z", 0.8],
      "M8.63152 12.7367L8.50057 12.5L6 8H11.263L8.63152 12.7367Z",
      ["M9.11205 13.6004L11 17L16 8H12.223L9.11205 13.6004Z", 0.6]
    ];
    return (s, o) => (d(), v(D, { icon: t }));
  }
}), Ot = /* @__PURE__ */ b({
  __name: "VoIconBin",
  setup(u) {
    return (t, s) => (d(), v(D, { icon: "$vuetify-bin" }));
  }
}), As = { key: 0 }, Ds = { class: "d-flex align-center justify-center pa-1 ga-2" }, Ts = /* @__PURE__ */ b({
  __name: "VoUserQuickActions",
  setup(u) {
    const t = j();
    return (s, o) => {
      const r = Ot, n = Ut;
      return d(), v(be, null, {
        default: i(() => [
          e(t).quickbar ? (d(), L("div", As, [
            h("div", Ds, [
              a(z, {
                class: "text-caption",
                color: e(t).colors.one,
                density: "comfortable",
                flat: "",
                href: "https://play.vuetifyjs.com",
                icon: "$vuetify-play",
                target: "_blank"
              }, {
                default: i(() => [
                  a(D),
                  a(se, {
                    activator: "parent",
                    location: "top",
                    text: "Vuetify Play"
                  })
                ]),
                _: 1
              }, 8, ["color"]),
              a(z, {
                class: "text-caption",
                color: e(t).colors.one,
                density: "comfortable",
                flat: "",
                href: "https://bin.vuetifyjs.com",
                icon: "",
                target: "_blank"
              }, {
                default: i(() => [
                  a(r),
                  a(se, {
                    activator: "parent",
                    location: "top",
                    text: "Vuetify Bin"
                  })
                ]),
                _: 1
              }, 8, ["color"]),
              a(z, {
                class: "text-caption",
                color: e(t).colors.one,
                density: "comfortable",
                flat: "",
                href: "https://issues.vuetifyjs.com",
                icon: "",
                target: "_blank"
              }, {
                default: i(() => [
                  a(n),
                  a(se, {
                    activator: "parent",
                    location: "top",
                    text: "Vuetify Issues"
                  })
                ]),
                _: 1
              }, 8, ["color"])
            ])
          ])) : x("", !0)
        ]),
        _: 1
      });
    };
  }
}), Us = { class: "mb-2" }, Os = { key: 0 }, Bs = { class: "d-flex ga-4 flex-wrap justify-center mb-4" }, Ns = { class: "text-h6" }, Ms = /* @__PURE__ */ b({
  __name: "VoUserAvatar",
  setup(u) {
    const t = q(), s = F(), o = j(), r = A(!1), n = V(() => {
      const p = [
        "https://cdn.vuetifyjs.com/docs/images/avatars/dark.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/blackguard.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/grass.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/wood.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/gold.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/planetary.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/grass-subscriber.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/wood-subscriber.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/gold-subscriber.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/planetary-subscriber.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/battlecruiser.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/cosmic-blue.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/blackhole.png",
        "https://cdn.vuetifyjs.com/docs/images/avatars/meteor.png"
      ];
      return s.isSubscriber && p.unshift("https://cdn.vuetifyjs.com/docs/images/avatars/one.png"), t.user && p.unshift(t.user.picture), p;
    });
    function l(p) {
      o.avatar = p;
    }
    function c() {
      s.isSubscriber && (r.value = !r.value);
    }
    return (p, m) => {
      var g;
      return d(), L("div", null, [
        he((d(), v(ne, {
          class: Rt([
            "border-md border-opacity-100 border-surface-light",
            {
              "cursor-pointer": e(s).isSubscriber
            }
          ]),
          color: "surface",
          size: "72",
          text: "Foobar",
          onClick: Ne(c, ["prevent", "stop"])
        }, {
          default: i(() => [
            e(t).user && e(o).avatar ? (d(), v(le, {
              key: 0,
              alt: "User avatar",
              src: e(o).avatar
            }, null, 8, ["src"])) : (d(), v(D, {
              key: 1,
              class: "mt-1",
              icon: "$vuetify",
              size: "x-large"
            }))
          ]),
          _: 1
        }, 8, ["class"])), [
          [en, e(s).isSubscriber]
        ]),
        h("div", Us, [
          a(be, null, {
            default: i(() => [
              e(r) ? (d(), L("div", Os, [
                a(E, {
                  class: "pt-6 pb-1",
                  flat: "",
                  rounded: "0"
                }, {
                  default: i(() => [
                    h("div", Bs, [
                      (d(!0), L(N, null, re(e(n), (f, C) => (d(), v(z, {
                        key: C,
                        active: e(o).avatar === f,
                        icon: "",
                        variant: "flat",
                        onClick: (_) => l(f)
                      }, {
                        default: i(() => [
                          a(ne, {
                            eager: "",
                            image: f
                          }, null, 8, ["image"])
                        ]),
                        _: 2
                      }, 1032, ["active", "onClick"]))), 128))
                    ])
                  ]),
                  _: 1
                })
              ])) : x("", !0)
            ]),
            _: 1
          })
        ]),
        h("div", Ns, S(((g = e(t).user) == null ? void 0 : g.name) ?? "Guest"), 1)
      ]);
    };
  }
}), Fs = /* @__PURE__ */ b({
  __name: "VoUserBadges",
  setup(u) {
    const t = q(), s = F(), o = V(() => {
      var r;
      return s.github || s.discord || s.isSubscriber || ((r = t.user) == null ? void 0 : r.isAdmin);
    });
    return (r, n) => e(o) ? (d(), v(Pe, {
      key: 0,
      class: "align-center position-absolute ms-2 d-flex ga-2 pa-2",
      color: "rgba(0,0,0,.54)",
      rounded: "lg",
      style: { left: "0" }
    }, {
      default: i(() => {
        var l;
        return [
          (l = e(t).user) != null && l.isAdmin ? (d(), v(se, {
            key: 0,
            location: "bottom",
            text: "Vuetify Administrator"
          }, {
            activator: i(({ props: c }) => [
              a(D, Y({
                color: "blue",
                icon: "$vuetify"
              }, c, { size: "16" }), null, 16)
            ]),
            _: 1
          })) : x("", !0),
          e(s).isSubscriber ? (d(), v(se, {
            key: 1,
            location: "bottom",
            text: "Vuetify One Subscriber"
          }, {
            activator: i(({ props: c }) => [
              a(D, Y({
                color: "amber-darken-2",
                icon: `svg:${e(Oo)}`
              }, c, { size: "16" }), null, 16, ["icon"])
            ]),
            _: 1
          })) : x("", !0),
          e(s).github ? (d(), v(se, {
            key: 2,
            location: "bottom",
            text: "GitHub Sponsor"
          }, {
            activator: i(({ props: c }) => [
              a(D, Y({
                color: "white",
                icon: "$github"
              }, c, { size: "16" }), null, 16)
            ]),
            _: 1
          })) : x("", !0),
          e(s).discord ? (d(), v(se, {
            key: 3,
            location: "bottom",
            text: "Discord Subscriber"
          }, {
            activator: i(({ props: c }) => [
              a(D, Y({
                color: "white",
                icon: "$discord"
              }, c, { size: "16" }), null, 16)
            ]),
            _: 1
          })) : x("", !0)
        ];
      }),
      _: 1
    })) : x("", !0);
  }
}), zs = { class: "d-flex flex-grow-1 justify-end fill-height align-start" }, js = {
  key: "reset",
  class: "align-self-end"
}, Ps = /* @__PURE__ */ b({
  __name: "VoUserColors",
  setup(u) {
    const t = q(), s = F(), o = j(), r = A(!1);
    function n() {
      o.colors.one = "surface-light";
    }
    return (l, c) => {
      const p = Fs, m = Ue;
      return d(), L(N, null, [
        a(le, {
          color: e(t).user ? e(o).colors.one : "surface-light",
          "content-class": "d-flex align-start justify-end pa-2",
          cover: "",
          flat: "",
          height: "88",
          rounded: "0"
        }, {
          default: i(() => [
            h("div", zs, [
              a(p),
              a(qo, null, {
                default: i(() => [
                  he(h("div", js, [
                    a(m, {
                      class: "ms-2 me-1",
                      color: "inherit",
                      density: "comfortable",
                      disabled: e(o).colors.one === "surface-light",
                      icon: `svg:${e(Bo)}`,
                      title: "Revert to Default",
                      variant: "text",
                      onClick: n
                    }, null, 8, ["disabled", "icon"])
                  ], 512), [
                    [ze, e(r)]
                  ])
                ]),
                _: 1
              }),
              e(s).isSubscriber ? (d(), v(m, {
                key: 0,
                active: e(r),
                class: "align-self-end",
                color: "inherit",
                density: "comfortable",
                icon: e(r) ? `svg:${e(Ae)}` : "$edit",
                title: "Edit One Header Color",
                variant: e(r) ? "text" : "plain",
                onClick: c[0] || (c[0] = (g) => r.value = !e(r))
              }, {
                default: i(() => [
                  a(Re, { "leave-absolute": "" }, {
                    default: i(() => [
                      (d(), v(D, {
                        key: String(e(r))
                      }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["active", "icon", "variant"])) : x("", !0)
            ])
          ]),
          _: 1
        }, 8, ["color"]),
        a(be, null, {
          default: i(() => [
            e(r) ? (d(), v(nn, {
              key: 0,
              elevation: "0",
              height: "250",
              "hide-canvas": "",
              "hide-inputs": "",
              "hide-sliders": "",
              "model-value": e(o).colors.one !== "surface-light" ? e(o).colors.one : void 0,
              rounded: "0",
              "show-swatches": "",
              "swatches-max-height": "200",
              width: "278",
              "onUpdate:modelValue": c[1] || (c[1] = (g) => e(o).colors.one = g)
            }, null, 8, ["model-value"])) : x("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
}), Rs = { class: "text-center mt-n9 mb-4" }, Hs = /* @__PURE__ */ b({
  __name: "VoUserMenu",
  setup(u) {
    const t = Ze(), s = F(), o = M();
    return R(() => t.banner, async () => {
      var r, n;
      await new Promise((l) => setTimeout(l, 300)), s.isOpen && ((n = (r = o.value) == null ? void 0 : r.updateLocation) == null || n.call(r));
    }, { flush: "pre" }), (r, n) => {
      const l = Ps, c = Ms, p = Ts, m = Is, g = Dt;
      return d(), v($t, {
        ref_key: "menu",
        ref: o,
        modelValue: e(s).isOpen,
        "onUpdate:modelValue": n[0] || (n[0] = (f) => e(s).isOpen = f),
        activator: "parent",
        "close-on-click": !1,
        "close-on-content-click": !1,
        eager: "",
        location: "bottom end"
      }, {
        default: i(() => [
          a(E, {
            border: "",
            rounded: "lg",
            width: "280"
          }, {
            default: i(() => [
              a(l),
              h("div", Rs, [
                a(c),
                a(p)
              ]),
              a(J),
              a(m),
              a(J),
              a(g)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
}), Es = { class: "me-n3" }, qs = /* @__PURE__ */ b({
  __name: "VoTeamInvite",
  setup(u) {
    const t = $e(), s = V(() => {
      var r, n;
      return ((r = t.team) == null ? void 0 : r.name) ?? `${(n = t.team) == null ? void 0 : n.owner.name}'s team`;
    });
    function o(r) {
      t.clearTeamQuery(), r.value = !1;
    }
    return (r, n) => e(t).teamInviteDialog ? (d(), v(tt, {
      key: 0,
      modelValue: e(t).teamInviteDialog,
      "onUpdate:modelValue": n[1] || (n[1] = (l) => e(t).teamInviteDialog = l),
      "max-width": "500"
    }, {
      default: i(({ isActive: l }) => [
        a(E, {
          "prepend-icon": `svg:${e(No)}`,
          rounded: "lg",
          title: "Join a Team"
        }, {
          append: i(() => [
            h("div", Es, [
              a(z, {
                icon: "$close",
                size: "x-small",
                variant: "text",
                onClick: (c) => o(l)
              }, null, 8, ["onClick"])
            ])
          ]),
          text: i(() => [
            n[2] || (n[2] = O(" You have been invited to join ")),
            h("strong", null, S(e(s)), 1),
            n[3] || (n[3] = O("! "))
          ]),
          default: i(() => [
            a(J, { opacity: ".2" }),
            a(Ho, { class: "bg-surface-light" }, {
              default: i(() => [
                a(z, {
                  disabled: e(t).isLoading,
                  rounded: "lg",
                  text: "Cancel",
                  variant: "plain",
                  onClick: (c) => o(l)
                }, null, 8, ["disabled", "onClick"]),
                a(Go),
                a(z, {
                  "append-icon": "$success",
                  color: "success",
                  disabled: e(t).isLoading,
                  rounded: "lg",
                  text: "Accept",
                  variant: "flat",
                  onClick: n[0] || (n[0] = (c) => e(t).joinTeam())
                }, null, 8, ["disabled"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["prepend-icon"])
      ]),
      _: 1
    }, 8, ["modelValue"])) : x("", !0);
  }
}), Ws = { key: 0 }, Bt = /* @__PURE__ */ b({
  __name: "VoAuthBtn",
  props: {
    external: Boolean
  },
  setup(u) {
    const t = q(), s = F(), o = j(), { lgAndUp: r } = me(), n = V(() => s.isOpen || !t.user ? o.colors.one === "surface-light" ? "primary" : o.colors.one : "surface-light"), { smAndUp: l } = me();
    return (c, p) => {
      const m = Hs, g = Ue, f = fn, C = At, _ = rn;
      return d(), L(N, null, [
        a(f, {
          "offset-y": e(t).user ? 5 : 0
        }, {
          default: i(() => [
            a(g, Y({
              [`${e(r) ? "append-" : ""}icon`]: e(t).user ? void 0 : `svg:${e(dt)}`
            }, {
              active: "",
              border: !!e(t).user,
              class: "vo-auth-btn",
              color: e(n),
              icon: e(t).user || e(t).isLoading || !e(l),
              loading: e(t).isLoading,
              size: e(l) ? "default" : "small",
              style: { transition: ".2s ease" },
              variant: e(t).user ? e(s).isOpen ? "outlined" : "text" : "flat"
            }), {
              default: i(() => [
                e(t).user ? (d(), v(ne, {
                  key: 0,
                  image: e(o).avatar || e(t).user.picture || ""
                }, null, 8, ["image"])) : (d(), L(N, { key: 1 }, [
                  e(l) ? (d(), L("span", Ws, "Login")) : (d(), v(D, {
                    key: 1,
                    icon: `svg:${e(dt)}`
                  }, null, 8, ["icon"]))
                ], 64)),
                a(m)
              ]),
              _: 1
            }, 16, ["border", "color", "icon", "loading", "size", "variant"])
          ]),
          _: 1
        }, 8, ["offset-y"]),
        a(C),
        a(qs),
        a(_)
      ], 64);
    };
  }
}), Zs = /* @__PURE__ */ b({
  __name: "VoAppBar",
  props: {
    logo: {}
  },
  setup(u) {
    const t = u, s = He(), o = We(), r = V(() => `https://cdn.vuetifyjs.com/docs/images/one/logos/${t.logo}-logo-${s.current.value.dark ? "dark" : "light"}.png`);
    return (n, l) => {
      const c = Ht("router-link"), p = Bt;
      return d(), v(wt, {
        class: "border-b",
        image: e(o).suit["app-bar"],
        name: "vo-app-bar"
      }, Z({
        prepend: i(() => [
          a(c, {
            class: "ps-2",
            to: "/"
          }, {
            default: i(() => [
              a(le, {
                src: e(r),
                width: "128"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          B(n.$slots, "prepend")
        ]),
        append: i(() => [
          B(n.$slots, "append"),
          n.$slots.append ? (d(), v(J, {
            key: 0,
            class: "align-self-center h-100 mx-2 mx-sm-4",
            length: "20",
            vertical: ""
          })) : x("", !0),
          a(p)
        ]),
        default: i(() => [
          B(n.$slots, "default")
        ]),
        _: 2
      }, [
        n.$slots.title ? {
          name: "title",
          fn: i(() => [
            B(n.$slots, "title")
          ]),
          key: "0"
        } : void 0,
        n.$slots.extension ? {
          name: "extension",
          fn: i(() => [
            B(n.$slots, "extension")
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["image"]);
    };
  }
}), Gs = ["id"], Qs = /* @__PURE__ */ b({
  __name: "VoScript",
  props: {
    id: {
      type: String,
      required: !0
    },
    scriptId: {
      type: String,
      required: !0
    },
    src: {
      type: String,
      required: !0
    }
  },
  emits: ["script:error", "script:load"],
  setup(u, { emit: t }) {
    const s = u, o = t, r = M(), n = M();
    return Ke(async () => {
      const l = document.createElement("script"), c = () => o("script:error");
      l.type = "text/javascript", l.id = s.scriptId, l.src = s.src, l.addEventListener("load", () => o("script:load")), l.onerror = c, n.value = l;
    }), Fe(() => {
      n.value && r.value && r.value.append(n.value);
    }), Et(() => {
      n.value && r.value && n.value.remove();
    }), (l, c) => (d(), L("div", {
      id: u.id,
      ref_key: "rootEl",
      ref: r
    }, null, 8, Gs));
  }
}), Ys = {
  key: 0,
  class: "v-footer__image"
}, Js = /* @__PURE__ */ b({
  __name: "VoFooter",
  props: {
    image: {}
  },
  setup(u) {
    return (t, s) => (d(), v(sn, {
      class: "vo-footer",
      height: "40"
    }, {
      default: i(() => [
        t.image || t.$slots.image ? (d(), L("div", Ys, [
          t.$slots.image ? B(t.$slots, "image", { key: 0 }, void 0, !0) : (d(), v(le, {
            key: 1,
            cover: "",
            position: "left",
            src: t.image
          }, null, 8, ["src"]))
        ])) : x("", !0),
        B(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }));
  }
}), rt = (u, t) => {
  const s = u.__vccOpts || u;
  for (const [o, r] of t)
    s[o] = r;
  return s;
}, Nt = /* @__PURE__ */ rt(Js, [["__scopeId", "data-v-31335c0a"]]), Xs = ["href", "title"], Ks = {
  class: "text-caption text-disabled",
  style: { position: "absolute", right: "16px" }
}, ea = /* @__PURE__ */ b({
  __name: "VoSocialFooter",
  setup(u) {
    const t = We(), s = [
      {
        title: "Vuetify Documentation",
        icon: "$vuetify",
        href: "https://vuetifyjs.com/"
      },
      {
        title: "Vuetify Support",
        icon: `svg:${Mo}`,
        href: "https://support.vuetifyjs.com/"
      },
      {
        title: "Vuetify X",
        icon: "$x",
        href: "https://x.com/vuetifyjs"
      },
      {
        title: "Vuetify GitHub",
        icon: "$github",
        href: "https://github.com/vuetifyjs/vuetify"
      },
      {
        title: "Vuetify Discord",
        icon: "$discord",
        href: "https://community.vuetifyjs.com/"
      },
      {
        title: "Vuetify Reddit",
        icon: "$reddit",
        href: "https://reddit.com/r/vuetifyjs"
      }
    ];
    return (o, r) => {
      const n = Nt;
      return d(), v(n, {
        class: "vo-footer",
        height: "40",
        image: e(t).suit.footer
      }, Z({
        default: i(() => [
          (d(), L(N, null, re(s, (l) => h("a", {
            key: l.title,
            class: "d-inline-block mx-2 social-link",
            href: l.href,
            rel: "noopener noreferrer",
            target: "_blank",
            title: l.title
          }, [
            a(D, {
              icon: l.icon,
              size: l.icon === "$vuetify" ? 24 : 16
            }, null, 8, ["icon", "size"])
          ], 8, Xs)), 64)),
          h("div", Ks, [
            O(" © 2016-" + S((/* @__PURE__ */ new Date()).getFullYear()) + " ", 1),
            r[0] || (r[0] = h("span", { class: "d-none d-sm-inline-block" }, "Vuetify, LLC", -1))
          ])
        ]),
        _: 2
      }, [
        o.$slots.image ? {
          name: "image",
          fn: i(() => [
            B(o.$slots, "image", {}, void 0, !0)
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["image"]);
    };
  }
}), ta = /* @__PURE__ */ rt(ea, [["__scopeId", "data-v-7a9688b8"]]), oa = /* @__PURE__ */ b({
  __name: "VoNotificationsBanner",
  props: {
    demo: { type: Boolean }
  },
  setup(u) {
    qt((_) => {
      var k;
      return {
        "201b10d9": (k = e(l)) == null ? void 0 : k.metadata.bg_blur
      };
    });
    const t = u, { mdAndUp: s } = me(), o = et(), r = j(), n = Ze(), l = V(() => n.banner), c = V(() => {
      var _, k;
      return ((_ = l.value) == null ? void 0 : _.metadata.height) || ((k = l.value) != null && k.metadata.subtext ? 88 : 48);
    }), p = V(() => t.demo ? !0 : !l.value || !r.notifications.last.banner.includes(l.value.slug));
    function m() {
      t.demo || l.value && r.notifications.last.banner.push(l.value.slug);
    }
    async function g(_) {
      var $;
      if (!l.value) return;
      setTimeout(() => m(), 500);
      const k = (($ = l.value) == null ? void 0 : $.metadata) ?? { link: "" };
      if (!k.link.includes("?one=")) return;
      _.preventDefault(), _.stopPropagation();
      const y = k.link.split("?one=")[1];
      o.push({ query: { one: y } });
    }
    const f = V(() => {
      var k, y;
      const _ = ((k = l.value) == null ? void 0 : k.metadata) ?? { link: "" };
      return {
        href: _.link.startsWith("http") ? _.link : void 0,
        target: _.link.startsWith("http") ? "_blank" : void 0,
        to: _.link.startsWith("http") ? void 0 : _.link,
        ...(y = l.value) == null ? void 0 : y.metadata.attributes
      };
    }), C = V(() => {
      var y, $;
      const _ = ($ = (y = l.value) == null ? void 0 : y.metadata.images.bg) == null ? void 0 : $.url;
      if (!(_ != null && _.startsWith("https://cdn.cosmicjs.com/"))) return _;
      const k = new URL(_);
      return k.host = "imgix.cosmicjs.com", k.search = new URLSearchParams({
        auto: "format,compress",
        q: "10",
        fit: "crop",
        w: "4096",
        h: "256"
      }).toString(), k.toString();
    });
    return (_, k) => e(l) ? (d(), v(wt, {
      key: 0,
      color: e(l).metadata.color,
      flat: "",
      height: e(c),
      image: e(C),
      location: _.demo ? "bottom" : void 0,
      "model-value": e(p),
      order: "-1"
    }, {
      default: i(() => [
        a(ye, Y({
          active: !1,
          class: "flex-grow-1 py-6",
          lines: "two"
        }, e(f), { onClick: g }), {
          prepend: i(() => [
            e(l).metadata.images.logo ? (d(), v(ne, {
              key: 0,
              icon: "$vuetify",
              image: e(l).metadata.images.logo.url,
              size: "x-large",
              tile: ""
            }, null, 8, ["image"])) : x("", !0)
          ]),
          append: i(() => [
            e(s) && e(l).metadata.link && e(l).metadata.link_text ? (d(), v(Ee, { key: 0 }, {
              default: i(({ isHovering: y, props: $ }) => [
                a(z, Y({
                  "append-icon": `svg:${e(je)}`,
                  class: "text-none me-2",
                  color: e(l).metadata.link_color,
                  elevation: y ? 8 : 0,
                  title: e(l).metadata.link_text
                }, {
                  ...$,
                  ...e(f)
                }, {
                  variant: "elevated",
                  onClick: Ne(g, ["stop"])
                }), {
                  default: i(() => [
                    O(S(e(l).metadata.link_text), 1)
                  ]),
                  _: 2
                }, 1040, ["append-icon", "color", "elevation", "title"])
              ]),
              _: 1
            })) : x("", !0),
            e(l).metadata.closable ? (d(), v(z, {
              key: 1,
              class: "ms-6 me-2",
              density: "comfortable",
              icon: "$clear",
              size: "small",
              variant: "plain",
              onClick: Ne(m, ["prevent", "stop"])
            })) : x("", !0)
          ]),
          default: i(() => [
            e(l).metadata.text ? (d(), v(yt, {
              key: 0,
              class: "text-subtitle-2 text-md-subtitle-1 font-weight-medium"
            }, {
              default: i(() => [
                O(S(e(l).metadata.text), 1)
              ]),
              _: 1
            })) : x("", !0),
            e(l).metadata.subtext ? (d(), v(jo, { key: 1 }, {
              default: i(() => [
                O(S(e(l).metadata.subtext), 1)
              ]),
              _: 1
            })) : x("", !0)
          ]),
          _: 1
        }, 16)
      ]),
      _: 1
    }, 8, ["color", "height", "image", "location", "model-value"])) : x("", !0);
  }
}), na = /* @__PURE__ */ rt(oa, [["__scopeId", "data-v-af468337"]]), sa = {
  key: 0,
  class: "text-uppercase position-absolute ms-auto font-weight-medium on-surface-light",
  style: { right: "12px", bottom: "8px", "font-size": "10px" }
}, Mt = /* @__PURE__ */ b({
  __name: "VoPromotionsCard",
  props: {
    caption: {},
    minHeight: {}
  },
  setup(u) {
    return (t, s) => (d(), v(E, {
      class: "d-inline-flex flex-child-1 position-relative",
      color: "surface-light",
      flat: "",
      rel: "noopener",
      rounded: "",
      target: "_blank"
    }, Z({
      default: i(() => [
        a(an, {
          "min-height": t.minHeight,
          width: "100%"
        }, {
          default: i(() => [
            B(t.$slots, "default")
          ]),
          _: 3
        }, 8, ["min-height"]),
        t.caption ? (d(), L("div", sa, S(t.caption), 1)) : x("", !0)
      ]),
      _: 2
    }, [
      t.$slots.prepend ? {
        name: "prepend",
        fn: i(() => [
          B(t.$slots, "prepend")
        ]),
        key: "0"
      } : void 0,
      t.$slots.image ? {
        name: "image",
        fn: i(() => [
          B(t.$slots, "image")
        ]),
        key: "1"
      } : void 0
    ]), 1024));
  }
}), lt = G("promotions", () => {
  const u = K(), t = M([]), s = A(!1), o = A(!1), r = V(() => t.value.filter((c) => c.metadata.discoverable));
  Ke(l);
  function n(c) {
    const p = c.filter((m) => m.metadata.active);
    return p[Math.floor(Math.random() * p.length)];
  }
  async function l() {
    try {
      s.value = !0;
      const c = await u.get("/one/promotions");
      t.value = c.promotions;
    } catch {
    } finally {
      s.value = !1, o.value = !0;
    }
    return t.value;
  }
  return {
    all: t,
    isLoading: s,
    hasLoaded: o,
    discoverable: r,
    index: l,
    random: n
  };
}), aa = /* @__PURE__ */ b({
  __name: "VoPromotionsCardHighlight",
  props: {
    slug: {}
  },
  setup(u) {
    const t = u, s = q(), o = lt(), r = He(), n = j(), l = V(() => {
      if (!(s.user && n.disableAds))
        return t.slug ? o.all.find((m) => m.slug === t.slug) : o.random(o.all);
    }), c = V(() => {
      var g, f;
      const m = r.current.value.dark ? "logodark" : "logolight";
      return (f = (g = l.value) == null ? void 0 : g.metadata.images[m]) == null ? void 0 : f.url;
    }), p = V(() => {
      var g, f;
      const m = r.current.value.dark ? "bgdark" : "bglight";
      return (f = (g = l.value) == null ? void 0 : g.metadata.images[m]) == null ? void 0 : f.url;
    });
    return (m, g) => {
      var C, _, k;
      const f = Mt;
      return e(l) || !e(o).hasLoaded ? (d(), v(f, {
        key: 0,
        class: "vo-promotions-card-highlight",
        color: ((C = e(l)) == null ? void 0 : C.metadata.color) ?? "surface",
        height: "60",
        href: (_ = e(l)) == null ? void 0 : _.metadata.url,
        image: e(p),
        "max-width": "720",
        "prepend-avatar": e(c),
        title: (k = e(l)) == null ? void 0 : k.metadata.short_text,
        width: "100%"
      }, Z({
        default: i(() => [
          e(o).hasLoaded ? x("", !0) : (d(), v(Le, {
            key: 0,
            class: "flex-1-0 overflow-hidden",
            color: "transparent",
            height: "60",
            loading: "",
            type: "image"
          }))
        ]),
        _: 2
      }, [
        e(l) ? {
          name: "prepend",
          fn: i(() => [
            a(ne, {
              class: "my-n4 me-4",
              icon: "$vuetify",
              size: "36"
            })
          ]),
          key: "0"
        } : void 0,
        e(l) ? {
          name: "image",
          fn: i(() => [
            a(le, { position: "right" })
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["color", "href", "image", "prepend-avatar", "title"])) : x("", !0);
    };
  }
}), ia = { class: "d-flex ga-4" }, ra = { class: "d-flex align-start ga-4" }, la = { class: "text-caption on-surface-light" }, ua = /* @__PURE__ */ b({
  __name: "VoPromotionsCardVuetify",
  props: {
    slug: {}
  },
  setup(u) {
    const t = u, s = q(), o = lt(), r = j(), n = V(() => {
      if (!(s.user && r.disableAds && !r.showHouseAds))
        return t.slug ? o.all.find((l) => l.slug === t.slug) : o.random(r.disableAds && r.showHouseAds ? o.discoverable : o.all);
    });
    return (l, c) => {
      var m, g;
      const p = Mt;
      return e(n) || !e(o).hasLoaded ? (d(), v(p, {
        key: 0,
        border: "",
        caption: "ads via vuetify",
        class: "vo-promotions-card-vuetify pa-2",
        href: (g = (m = e(n)) == null ? void 0 : m.metadata) == null ? void 0 : g.url,
        width: "360"
      }, {
        default: i(() => {
          var f, C, _;
          return [
            h("div", ia, [
              e(o).hasLoaded ? e(n) ? (d(), L(N, { key: 1 }, [
                a(le, {
                  cover: "",
                  height: "100",
                  "max-width": "130",
                  position: "right",
                  rounded: "s",
                  src: (C = (f = e(n).metadata) == null ? void 0 : f.images.default) == null ? void 0 : C.url,
                  width: "100%"
                }, null, 8, ["src"]),
                h("div", ra, [
                  h("div", la, S((_ = e(n).metadata) == null ? void 0 : _.text), 1)
                ])
              ], 64)) : x("", !0) : (d(), L(N, { key: 0 }, [
                a(Le, {
                  class: "flex-1-0 overflow-hidden",
                  color: "transparent",
                  loading: "",
                  "max-height": "100",
                  "min-width": "130",
                  type: "image"
                }),
                a(Le, {
                  class: "flex-1-0 ms-n3 mt-n3",
                  color: "transparent",
                  loading: "",
                  "max-height": "100",
                  type: "text@3"
                })
              ], 64))
            ])
          ];
        }),
        _: 1
      }, 8, ["href"])) : x("", !0);
    };
  }
}), ca = ["href"], da = /* @__PURE__ */ b({
  __name: "VoPromotionsFooter",
  props: {
    slug: {}
  },
  setup(u) {
    const t = u, s = q(), o = lt(), r = j(), n = He(), l = V(() => {
      if (!(s.user && r.disableAds))
        return t.slug ? o.all.find((m) => m.slug === t.slug) : o.random(o.all);
    }), c = V(() => {
      var g, f;
      const m = n.current.value.dark ? "logodark" : "logolight";
      return (f = (g = l.value) == null ? void 0 : g.metadata.images[m]) == null ? void 0 : f.url;
    }), p = V(() => {
      var g, f;
      const m = n.current.value.dark ? "bgdark" : "bglight";
      return (f = (g = l.value) == null ? void 0 : g.metadata.images[m]) == null ? void 0 : f.url;
    });
    return (m, g) => {
      var C;
      const f = Nt;
      return d(), v(f, {
        color: ((C = e(l)) == null ? void 0 : C.metadata.color) ?? "surface",
        image: e(p),
        style: { transform: "translateY(0)" }
      }, {
        default: i(() => {
          var _, k, y;
          return [
            h("a", {
              class: "d-flex align-center text-decoration-none py-2 px-4 ms-n4 flex-1-0 me-n4 position-relative",
              href: (_ = e(l)) == null ? void 0 : _.metadata.url,
              rel: "noopener noreferrer",
              style: { color: "inherit" },
              target: "_blank"
            }, [
              a(ne, {
                class: "me-4",
                icon: "$vuetify",
                image: e(c),
                size: "24"
              }, null, 8, ["image"]),
              h("div", null, S((k = e(l)) == null ? void 0 : k.metadata.text), 1),
              (y = e(l)) != null && y.metadata.advertisement ? (d(), v(ie, {
                key: 0,
                class: "ms-auto me-n4 align-self-end mb-n2 py-1 ps-3",
                rounded: "0 ts-lg",
                size: "x-small",
                text: "SPONSORED",
                variant: "flat"
              })) : x("", !0)
            ], 8, ca)
          ];
        }),
        _: 1
      }, 8, ["color", "image"]);
    };
  }
}), pa = G("spots", () => {
  const u = K(), t = it(), s = M([]), o = A(!1), r = V(() => s.value.find(({
    metadata: {
      site: l,
      active: c
    }
  }) => c ? l.includes("dev") && !1 || l.includes("*") ? !0 : l.some((p) => t.id.includes(p)) : !1));
  async function n() {
    try {
      o.value = !0;
      const l = await u.get("/one/spots");
      s.value = l.spots;
    } catch {
    } finally {
      o.value = !1;
    }
    return s.value;
  }
  return {
    all: s,
    isLoading: o,
    spot: r,
    index: n
  };
}), ma = ["href"], fa = /* @__PURE__ */ b({
  __name: "VoSpot",
  setup(u) {
    const t = pa();
    return (s, o) => {
      var r;
      return e(t).spot ? (d(), L("a", {
        key: 0,
        href: e(t).spot.metadata.href,
        rel: "noopener noreferrer sponsored",
        target: "_blank"
      }, [
        a(le, {
          class: "mx-auto",
          color: e(t).spot.metadata.image ? void 0 : "surface",
          rounded: "",
          src: (r = e(t).spot.metadata.image) == null ? void 0 : r.url,
          width: "225"
        }, null, 8, ["color", "src"])
      ], 8, ma)) : x("", !0);
    };
  }
}), ai = {
  discord: ["M22,24L16.75,19L17.38,21H4.5A2.5,2.5 0 0,1 2,18.5V3.5A2.5,2.5 0 0,1 4.5,1H19.5A2.5,2.5 0 0,1 22,3.5V24M12,6.8C9.32,6.8 7.44,7.95 7.44,7.95C8.47,7.03 10.27,6.5 10.27,6.5L10.1,6.33C8.41,6.36 6.88,7.53 6.88,7.53C5.16,11.12 5.27,14.22 5.27,14.22C6.67,16.03 8.75,15.9 8.75,15.9L9.46,15C8.21,14.73 7.42,13.62 7.42,13.62C7.42,13.62 9.3,14.9 12,14.9C14.7,14.9 16.58,13.62 16.58,13.62C16.58,13.62 15.79,14.73 14.54,15L15.25,15.9C15.25,15.9 17.33,16.03 18.73,14.22C18.73,14.22 18.84,11.12 17.12,7.53C17.12,7.53 15.59,6.36 13.9,6.33L13.73,6.5C13.73,6.5 15.53,7.03 16.56,7.95C16.56,7.95 14.68,6.8 12,6.8M9.93,10.59C10.58,10.59 11.11,11.16 11.1,11.86C11.1,12.55 10.58,13.13 9.93,13.13C9.29,13.13 8.77,12.55 8.77,11.86C8.77,11.16 9.28,10.59 9.93,10.59M14.1,10.59C14.75,10.59 15.27,11.16 15.27,11.86C15.27,12.55 14.75,13.13 14.1,13.13C13.46,13.13 12.94,12.55 12.94,11.86C12.94,11.16 13.45,10.59 14.1,10.59Z"],
  github: ["M12,2A10,10 0 0,0 2,12C2,16.42 4.87,20.17 8.84,21.5C9.34,21.58 9.5,21.27 9.5,21C9.5,20.77 9.5,20.14 9.5,19.31C6.73,19.91 6.14,17.97 6.14,17.97C5.68,16.81 5.03,16.5 5.03,16.5C4.12,15.88 5.1,15.9 5.1,15.9C6.1,15.97 6.63,16.93 6.63,16.93C7.5,18.45 8.97,18 9.54,17.76C9.63,17.11 9.89,16.67 10.17,16.42C7.95,16.17 5.62,15.31 5.62,11.5C5.62,10.39 6,9.5 6.65,8.79C6.55,8.54 6.2,7.5 6.75,6.15C6.75,6.15 7.59,5.88 9.5,7.17C10.29,6.95 11.15,6.84 12,6.84C12.85,6.84 13.71,6.95 14.5,7.17C16.41,5.88 17.25,6.15 17.25,6.15C17.8,7.5 17.45,8.54 17.35,8.79C18,9.5 18.38,10.39 18.38,11.5C18.38,15.32 16.04,16.16 13.81,16.41C14.17,16.72 14.5,17.33 14.5,18.26C14.5,19.6 14.5,20.68 14.5,21C14.5,21.27 14.66,21.59 15.17,21.5C19.14,20.16 22,16.42 22,12A10,10 0 0,0 12,2Z"],
  reddit: "M14.5 15.41C14.58 15.5 14.58 15.69 14.5 15.8C13.77 16.5 12.41 16.56 12 16.56C11.61 16.56 10.25 16.5 9.54 15.8C9.44 15.69 9.44 15.5 9.54 15.41C9.65 15.31 9.82 15.31 9.92 15.41C10.38 15.87 11.33 16 12 16C12.69 16 13.66 15.87 14.1 15.41C14.21 15.31 14.38 15.31 14.5 15.41M10.75 13.04C10.75 12.47 10.28 12 9.71 12C9.14 12 8.67 12.47 8.67 13.04C8.67 13.61 9.14 14.09 9.71 14.08C10.28 14.08 10.75 13.61 10.75 13.04M14.29 12C13.72 12 13.25 12.5 13.25 13.05S13.72 14.09 14.29 14.09C14.86 14.09 15.33 13.61 15.33 13.05C15.33 12.5 14.86 12 14.29 12M22 12C22 17.5 17.5 22 12 22S2 17.5 2 12C2 6.5 6.5 2 12 2S22 6.5 22 12M18.67 12C18.67 11.19 18 10.54 17.22 10.54C16.82 10.54 16.46 10.7 16.2 10.95C15.2 10.23 13.83 9.77 12.3 9.71L12.97 6.58L15.14 7.05C15.16 7.6 15.62 8.04 16.18 8.04C16.75 8.04 17.22 7.57 17.22 7C17.22 6.43 16.75 5.96 16.18 5.96C15.77 5.96 15.41 6.2 15.25 6.55L12.82 6.03C12.75 6 12.68 6.03 12.63 6.07C12.57 6.11 12.54 6.17 12.53 6.24L11.79 9.72C10.24 9.77 8.84 10.23 7.82 10.96C7.56 10.71 7.2 10.56 6.81 10.56C6 10.56 5.35 11.21 5.35 12C5.35 12.61 5.71 13.11 6.21 13.34C6.19 13.5 6.18 13.62 6.18 13.78C6.18 16 8.79 17.85 12 17.85C15.23 17.85 17.85 16.03 17.85 13.78C17.85 13.64 17.84 13.5 17.81 13.34C18.31 13.11 18.67 12.6 18.67 12Z",
  x: ["M2.04875 3.00002L9.77052 13.3248L1.99998 21.7192H3.74882L10.5519 14.3697L16.0486 21.7192H22L13.8437 10.8137L21.0765 3.00002H19.3277L13.0624 9.76874L8.0001 3.00002H2.04875ZM4.62054 4.28821H7.35461L19.4278 20.4308H16.6937L4.62054 4.28821Z"],
  "vuetify-bin": [
    ["M18.9112 5.03206L3.68692 8.88953C3.68692 8.88953 2.00252 6.21666 2 6.21428C2.02517 6.20794 18.6159 2.00476 18.6394 2L18.8944 4.8489L18.9095 5.01937L18.9112 5.03285V5.03206Z", 0.6],
    ["M19.4556 10.9994C19.4556 10.9994 7.06082 14.1417 7.05915 14.1386L5.3739 11.4641C5.41836 11.453 18.4582 8.14817 18.4993 8.13945L19.1838 7.9658L19.4556 10.9994Z", 1],
    "M20 17.0652C19.9916 17.0675 14.6826 18.4123 14.6742 18.4147C14.6994 17.3633 14.3353 16.3579 13.712 15.5563L19.7274 14.0331L20 17.066V17.0652Z",
    ["M12.353 16.0368C9.07567 12.843 3.90082 17.0493 6.66818 20.5975C9.94136 24.3844 15.773 19.6984 12.353 16.0368ZM11.1267 19.4129C10.2224 20.7664 7.79139 20.1099 7.82746 18.4686C8.04976 15.4897 12.7112 16.8495 11.1267 19.4129Z", 0.6]
  ],
  "vuetify-play": [
    "m6.376 13.184-4.11-7.192C1.505 4.66 2.467 3 4.003 3h8.532l-.953 1.576-.006.01-.396.677c-.429.732-.214 1.507.194 2.015.404.503 1.092.878 1.869.806a3.72 3.72 0 0 1 1.005.022c.276.053.434.143.523.237.138.146.38.635-.25 2.09-.893 1.63-1.553 1.722-1.847 1.677-.213-.033-.468-.158-.756-.406a4.95 4.95 0 0 1-.8-.927c-.39-.564-1.04-.84-1.66-.846-.625-.006-1.316.27-1.693.921l-.478.826-.911 1.506Z",
    ["M9.093 11.552c.046-.079.144-.15.32-.148a.53.53 0 0 1 .43.207c.285.414.636.847 1.046 1.2.405.35.914.662 1.516.754 1.334.205 2.502-.698 3.48-2.495l.014-.028.013-.03c.687-1.574.774-2.852-.005-3.675-.37-.391-.861-.586-1.333-.676a5.243 5.243 0 0 0-1.447-.044c-.173.016-.393-.073-.54-.257-.145-.18-.127-.316-.082-.392l.393-.672L14.287 3h5.71c1.536 0 2.499 1.659 1.737 2.992l-7.997 13.996c-.768 1.344-2.706 1.344-3.473 0l-3.037-5.314 1.377-2.278.004-.006.004-.007.481-.831Z", 0.6]
  ],
  "vuetify-studio": [
    ["M12.435 14.3194L12 21L6.87046 12.2799L12.435 14.3194Z", 1],
    ["M22 4L12.435 14.3194L6.87046 12.2799L9.26479 7.61064L12.435 14.3194L12 21L22 4Z", 0.5],
    ["M12.435 14.3194L22 4L9.26479 7.61064L12.435 14.3194Z", 1],
    ["M2 4L6.87046 12.2799L9.26479 7.61064L2 4Z", 1]
  ]
}, ii = G("bins", () => {
  const u = K(), t = M([]), s = A(!1), o = V(() => t.value.filter((l) => l.favorite)), r = V(() => t.value.filter((l) => l.pinned));
  async function n() {
    try {
      s.value = !0;
      const l = await u.get("/one/bins");
      t.value = l.bins;
    } catch {
    } finally {
      s.value = !1;
    }
    return t.value;
  }
  return {
    isLoading: s,
    pinned: r,
    favorites: o,
    all: t,
    index: n
  };
}), ri = G("products", () => {
  const u = K(), t = M([]), s = V(() => t.value.filter((n) => n.product_type === "Themes"));
  async function o() {
    if (t.value.length > 0)
      return t.value;
    try {
      const n = await u.get("/one/shopify/products");
      t.value = n.products;
    } catch {
    }
    return t.value;
  }
  function r(n) {
    return n.slice().sort(() => Math.random() - 0.5);
  }
  return {
    all: t,
    themes: s,
    index: o,
    randomize: r
  };
}), li = G("sponsors", () => {
  const u = K(), t = M([]), s = M([]), o = M(!1), r = V(() => {
    const c = {};
    for (const p of t.value) {
      const m = p.metadata.tier;
      c[m] || (c[m] = []), c[m].push(p);
    }
    return c;
  });
  Wt(n), Ke(n);
  async function n() {
    try {
      o.value = !0;
      const c = await u.get("/one/sponsors");
      s.value = c.sponsors;
    } catch {
    } finally {
      o.value = !1;
    }
    return s.value;
  }
  function l(c) {
    return t.value.find((p) => p.slug === c);
  }
  return {
    isLoading: o,
    all: s,
    sponsors: t,
    byTier: r,
    bySlug: l,
    index: n
  };
});
function ui() {
  function u(t) {
    t.component("VoAppBar", Zs), t.component("VoAuthBtn", Bt), t.component("VoAuthCard", It), t.component("VoAuthDialog", At), t.component("VoAuthListItem", Dt), t.component("VoIconBin", Ot), t.component("VoIconIssues", Ut), t.component("VoNotificationsBanner", na), t.component("VoPromotionsCardHighlight", aa), t.component("VoPromotionsCardVuetify", ua), t.component("VoPromotionsFooter", da), t.component("VoScript", Qs), t.component("VoSocialFooter", ta), t.component("VoSpot", fa);
  }
  return { install: u };
}
function ci(u, t) {
  return function(s) {
    const o = s.store;
    o.url = t, o.$id === "site" && (o.id = u);
  };
}
export {
  ai as aliases,
  ui as createOne,
  ci as one,
  q as useAuthStore,
  Ze as useBannersStore,
  ii as useBinsStore,
  es as useDownloadsStore,
  K as useHttpStore,
  qe as useNotificationsStore,
  F as useOneStore,
  ri as useProductsStore,
  lt as usePromotionsStore,
  xt as useQueueStore,
  We as useSettingsStore,
  it as useSiteStore,
  li as useSponsorsStore,
  pa as useSpotsStore,
  $e as useTeamStore,
  j as useUserStore
};
